/* eslint-disable */

/**
 * Auto Generated from Figma
 * Do not edit manually.
 * If you need to add new icons, please add them to the icons folder
 * and run the update-design-system target.
 */

import iconArrowLineLeft from './svg/iconArrowLineLeft.svg';
import iconArrowLineRight from './svg/iconArrowLineRight.svg';
import iconBuildings from './svg/iconBuildings.svg';
import iconCaretDown from './svg/iconCaretDown.svg';
import iconCaretRight from './svg/iconCaretRight.svg';
import iconCheck from './svg/iconCheck.svg';
import iconDiamond from './svg/iconDiamond.svg';
import iconDotsThreeVertical from './svg/iconDotsThreeVertical.svg';
import iconFunnelSimple from './svg/iconFunnelSimple.svg';
import iconHandWaving from './svg/iconHandWaving.svg';
import iconHouse from './svg/iconHouse.svg';
import iconMagnifyingGlass from './svg/iconMagnifyingGlass.svg';
import iconNewspaper from './svg/iconNewspaper.svg';
import iconNewspaperClipping from './svg/iconNewspaperClipping.svg';
import iconTrash from './svg/iconTrash.svg';
import iconUser from './svg/iconUser.svg';
import iconWarningCircle from './svg/iconWarningCircle.svg';
import iconX from './svg/iconX.svg';
import icon24 from './svg/icon24.svg';
import iconArrowUDownLeft from './svg/iconArrowUDownLeft.svg';
import iconArrowUDownRight from './svg/iconArrowUDownRight.svg';
import iconArrowULeftDown from './svg/iconArrowULeftDown.svg';
import iconArrowULeftUp from './svg/iconArrowULeftUp.svg';
import iconArrowURightDown from './svg/iconArrowURightDown.svg';
import iconArrowURightUp from './svg/iconArrowURightUp.svg';
import iconArrowUUpLeft from './svg/iconArrowUUpLeft.svg';
import iconArrowUUpRight from './svg/iconArrowUUpRight.svg';
import iconArrowsDownUp from './svg/iconArrowsDownUp.svg';
import iconArrowsHorizontal from './svg/iconArrowsHorizontal.svg';
import iconArrowsIn from './svg/iconArrowsIn.svg';
import iconArrowsInCardinal from './svg/iconArrowsInCardinal.svg';
import iconArrowsInLineHorizontal from './svg/iconArrowsInLineHorizontal.svg';
import iconArrowsInLineVertical from './svg/iconArrowsInLineVertical.svg';
import iconArrowsInSimple from './svg/iconArrowsInSimple.svg';
import iconArrowsLeftRight from './svg/iconArrowsLeftRight.svg';
import iconArrowsOut from './svg/iconArrowsOut.svg';
import iconArrowsOutCardinal from './svg/iconArrowsOutCardinal.svg';
import iconArrowsOutLineHorizontal from './svg/iconArrowsOutLineHorizontal.svg';
import iconArrowsOutLineVertical from './svg/iconArrowsOutLineVertical.svg';
import iconArrowsOutSimple from './svg/iconArrowsOutSimple.svg';
import iconArrowsVertical from './svg/iconArrowsVertical.svg';
import iconArrowsCounterClockwise from './svg/iconArrowsCounterClockwise.svg';
import iconArrowsClockwise from './svg/iconArrowsClockwise.svg';
import iconArrowBendLeftDown from './svg/iconArrowBendLeftDown.svg';
import iconArrowBendLeftUp from './svg/iconArrowBendLeftUp.svg';
import iconArrowBendDoubleUpLeft from './svg/iconArrowBendDoubleUpLeft.svg';
import iconArrowBendDoubleUpRight from './svg/iconArrowBendDoubleUpRight.svg';
import iconArrowArcLeft from './svg/iconArrowArcLeft.svg';
import iconArrowArcRight from './svg/iconArrowArcRight.svg';
import iconArrowBendDownLeft from './svg/iconArrowBendDownLeft.svg';
import iconArrowBendDownRight from './svg/iconArrowBendDownRight.svg';
import iconArrowBendRightDown from './svg/iconArrowBendRightDown.svg';
import iconArrowBendRightUp from './svg/iconArrowBendRightUp.svg';
import iconArrowBendUpLeft from './svg/iconArrowBendUpLeft.svg';
import iconArrowBendUpRight from './svg/iconArrowBendUpRight.svg';
import iconArrowFatDown from './svg/iconArrowFatDown.svg';
import iconArrowFatLeft from './svg/iconArrowFatLeft.svg';
import iconArrowFatLineDown from './svg/iconArrowFatLineDown.svg';
import iconArrowFatLineLeft from './svg/iconArrowFatLineLeft.svg';
import iconArrowFatLineRight from './svg/iconArrowFatLineRight.svg';
import iconArrowFatLineUp from './svg/iconArrowFatLineUp.svg';
import iconArrowFatLinesDown from './svg/iconArrowFatLinesDown.svg';
import iconArrowFatLinesLeft from './svg/iconArrowFatLinesLeft.svg';
import iconArrowFatLinesRight from './svg/iconArrowFatLinesRight.svg';
import iconArrowFatLinesUp from './svg/iconArrowFatLinesUp.svg';
import iconArrowFatRight from './svg/iconArrowFatRight.svg';
import iconArrowFatUp from './svg/iconArrowFatUp.svg';
import iconCaretCircleDoubleDown from './svg/iconCaretCircleDoubleDown.svg';
import iconCaretCircleDoubleLeft from './svg/iconCaretCircleDoubleLeft.svg';
import iconCaretCircleDoubleRight from './svg/iconCaretCircleDoubleRight.svg';
import iconCaretCircleDoubleUp from './svg/iconCaretCircleDoubleUp.svg';
import iconCaretCircleDown from './svg/iconCaretCircleDown.svg';
import iconCaretCircleLeft from './svg/iconCaretCircleLeft.svg';
import iconCaretCircleRight from './svg/iconCaretCircleRight.svg';
import iconCaretCircleUp from './svg/iconCaretCircleUp.svg';
import iconVariant10 from './svg/iconVariant10.svg';
import iconVariant9 from './svg/iconVariant9.svg';
import iconCaretUp from './svg/iconCaretUp.svg';
import iconCaretLeft from './svg/iconCaretLeft.svg';
import iconArrowSquareDown from './svg/iconArrowSquareDown.svg';
import iconArrowSquareDownLeft from './svg/iconArrowSquareDownLeft.svg';
import iconArrowSquareDownRight from './svg/iconArrowSquareDownRight.svg';
import iconArrowSquareIn from './svg/iconArrowSquareIn.svg';
import iconArrowSquareLeft from './svg/iconArrowSquareLeft.svg';
import iconArrowSquareOut from './svg/iconArrowSquareOut.svg';
import iconArrowSquareRight from './svg/iconArrowSquareRight.svg';
import iconArrowSquareUp from './svg/iconArrowSquareUp.svg';
import iconArrowSquareUpLeft from './svg/iconArrowSquareUpLeft.svg';
import iconArrowSquareUpRight from './svg/iconArrowSquareUpRight.svg';
import iconDown from './svg/iconDown.svg';
import iconDownLeft from './svg/iconDownLeft.svg';
import iconDownRight from './svg/iconDownRight.svg';
import iconLeft from './svg/iconLeft.svg';
import iconRight from './svg/iconRight.svg';
import iconUp from './svg/iconUp.svg';
import iconUpLeft from './svg/iconUpLeft.svg';
import iconUpRight from './svg/iconUpRight.svg';
import iconDirections10 from './svg/iconDirections10.svg';
import iconDirections9 from './svg/iconDirections9.svg';
import iconLeftDown from './svg/iconLeftDown.svg';
import iconLeftUp from './svg/iconLeftUp.svg';
import iconRightDown from './svg/iconRightDown.svg';
import iconRightUp from './svg/iconRightUp.svg';
import iconArrowLineDown from './svg/iconArrowLineDown.svg';
import iconArrowLineDownLeft from './svg/iconArrowLineDownLeft.svg';
import iconArrowLineDownRight from './svg/iconArrowLineDownRight.svg';
import iconArrowLineUp from './svg/iconArrowLineUp.svg';
import iconArrowLineUpLeft from './svg/iconArrowLineUpLeft.svg';
import iconArrowLineUpRight from './svg/iconArrowLineUpRight.svg';
import iconFile from './svg/iconFile.svg';
import iconFileArrowDown from './svg/iconFileArrowDown.svg';
import iconFileArrowUp from './svg/iconFileArrowUp.svg';
import iconFileAudio from './svg/iconFileAudio.svg';
import iconFileCloud from './svg/iconFileCloud.svg';
import iconFileCode from './svg/iconFileCode.svg';
import iconFileCss from './svg/iconFileCss.svg';
import iconFileCsv from './svg/iconFileCsv.svg';
import iconFileDoc from './svg/iconFileDoc.svg';
import iconFileDotted from './svg/iconFileDotted.svg';
import iconFileHtml from './svg/iconFileHtml.svg';
import iconFileImage from './svg/iconFileImage.svg';
import iconFileJpg from './svg/iconFileJpg.svg';
import iconFileJs from './svg/iconFileJs.svg';
import iconFileJsx from './svg/iconFileJsx.svg';
import iconFileLock from './svg/iconFileLock.svg';
import iconFileMinus from './svg/iconFileMinus.svg';
import iconFilePdf from './svg/iconFilePdf.svg';
import iconFilePlus from './svg/iconFilePlus.svg';
import iconFilePng from './svg/iconFilePng.svg';
import iconFilePpt from './svg/iconFilePpt.svg';
import iconFileRs from './svg/iconFileRs.svg';
import iconFileSearch from './svg/iconFileSearch.svg';
import iconFileText from './svg/iconFileText.svg';
import iconFileTs from './svg/iconFileTs.svg';
import iconFileTsx from './svg/iconFileTsx.svg';
import iconFileVideo from './svg/iconFileVideo.svg';
import iconFileVue from './svg/iconFileVue.svg';
import iconFileX from './svg/iconFileX.svg';
import iconFileXls from './svg/iconFileXls.svg';
import iconFileZip from './svg/iconFileZip.svg';
import iconFiles from './svg/iconFiles.svg';
import iconTextAa from './svg/iconTextAa.svg';
import iconTextBolder from './svg/iconTextBolder.svg';
import iconTextH from './svg/iconTextH.svg';
import iconTextHFive from './svg/iconTextHFive.svg';
import iconTextHFour from './svg/iconTextHFour.svg';
import iconTextHOne from './svg/iconTextHOne.svg';
import iconTextHSix from './svg/iconTextHSix.svg';
import iconTextHThree from './svg/iconTextHThree.svg';
import iconTextIndent from './svg/iconTextIndent.svg';
import iconTextItalic from './svg/iconTextItalic.svg';
import iconTextOutdent from './svg/iconTextOutdent.svg';
import iconTextStrikethrough from './svg/iconTextStrikethrough.svg';
import iconTextT from './svg/iconTextT.svg';
import iconTextUnderline from './svg/iconTextUnderline.svg';
import iconTextbox from './svg/iconTextbox.svg';
import iconCursorText from './svg/iconCursorText.svg';
import iconFolder from './svg/iconFolder.svg';
import iconFolderDotted from './svg/iconFolderDotted.svg';
import iconFolderLock from './svg/iconFolderLock.svg';
import iconFolderMinus from './svg/iconFolderMinus.svg';
import iconFolderNotch from './svg/iconFolderNotch.svg';
import iconFolderNotchMinus from './svg/iconFolderNotchMinus.svg';
import iconFolderNotchPlus from './svg/iconFolderNotchPlus.svg';
import iconFolderPlus from './svg/iconFolderPlus.svg';
import iconFolderSimple from './svg/iconFolderSimple.svg';
import iconFolderSimpleDotted from './svg/iconFolderSimpleDotted.svg';
import iconFolderSimpleLock from './svg/iconFolderSimpleLock.svg';
import iconFolderSimpleMinus from './svg/iconFolderSimpleMinus.svg';
import iconFolderSimplePlus from './svg/iconFolderSimplePlus.svg';
import iconFolderSimpleStar from './svg/iconFolderSimpleStar.svg';
import iconFolderSimpleUser from './svg/iconFolderSimpleUser.svg';
import iconFolderStar from './svg/iconFolderStar.svg';
import iconFolderUser from './svg/iconFolderUser.svg';
import iconFolders from './svg/iconFolders.svg';
import iconListChecks from './svg/iconListChecks.svg';
import iconListDashes from './svg/iconListDashes.svg';
import iconListNumbers from './svg/iconListNumbers.svg';
import iconListPlus from './svg/iconListPlus.svg';
import iconList from './svg/iconList.svg';
import iconListBullets from './svg/iconListBullets.svg';
import iconTextAlignCenter from './svg/iconTextAlignCenter.svg';
import iconTextAlignJustify from './svg/iconTextAlignJustify.svg';
import iconTextAlignLeft from './svg/iconTextAlignLeft.svg';
import iconTextAlignRight from './svg/iconTextAlignRight.svg';
import iconNote from './svg/iconNote.svg';
import iconNoteBlank from './svg/iconNoteBlank.svg';
import iconNotePencil from './svg/iconNotePencil.svg';
import iconNotebook from './svg/iconNotebook.svg';
import iconNotepad from './svg/iconNotepad.svg';
import iconKanban from './svg/iconKanban.svg';
import iconPresentation from './svg/iconPresentation.svg';
import iconPresentationChart from './svg/iconPresentationChart.svg';
import iconPrinter from './svg/iconPrinter.svg';
import iconProjectorScreen from './svg/iconProjectorScreen.svg';
import iconFloppyDisk from './svg/iconFloppyDisk.svg';
import iconProjectorScreenChart from './svg/iconProjectorScreenChart.svg';
import iconFloppyDiskBack from './svg/iconFloppyDiskBack.svg';
import iconArchive from './svg/iconArchive.svg';
import iconArchiveBox from './svg/iconArchiveBox.svg';
import iconCards from './svg/iconCards.svg';
import iconClipboard from './svg/iconClipboard.svg';
import iconClipboardText from './svg/iconClipboardText.svg';
import iconPushPin from './svg/iconPushPin.svg';
import iconPushPinSimple from './svg/iconPushPinSimple.svg';
import iconPushPinSimpleSlash from './svg/iconPushPinSimpleSlash.svg';
import iconSortAscending from './svg/iconSortAscending.svg';
import iconSortDescending from './svg/iconSortDescending.svg';
import iconCopy from './svg/iconCopy.svg';
import iconCopySimple from './svg/iconCopySimple.svg';
import iconBriefcase from './svg/iconBriefcase.svg';
import iconBriefcaseMetal from './svg/iconBriefcaseMetal.svg';
import iconTrashSimple from './svg/iconTrashSimple.svg';
import iconPaperclip from './svg/iconPaperclip.svg';
import iconPaperclipHorizontal from './svg/iconPaperclipHorizontal.svg';
import iconBellRinging from './svg/iconBellRinging.svg';
import iconBellSlash from './svg/iconBellSlash.svg';
import iconBellSimpleRinging from './svg/iconBellSimpleRinging.svg';
import iconBluetooth from './svg/iconBluetooth.svg';
import iconBluetoothConnected from './svg/iconBluetoothConnected.svg';
import iconBluetoothSlash from './svg/iconBluetoothSlash.svg';
import iconBluetoothX from './svg/iconBluetoothX.svg';
import iconCellSignalFull from './svg/iconCellSignalFull.svg';
import iconCellSignalHigh from './svg/iconCellSignalHigh.svg';
import iconCellSignalLow from './svg/iconCellSignalLow.svg';
import iconCellSignalMedium from './svg/iconCellSignalMedium.svg';
import iconCellSignalNone from './svg/iconCellSignalNone.svg';
import iconCellSignalSlash from './svg/iconCellSignalSlash.svg';
import iconCellSignalX from './svg/iconCellSignalX.svg';
import iconFalse from './svg/iconFalse.svg';
import iconTrue from './svg/iconTrue.svg';
import iconMagnifyingGlassMinus from './svg/iconMagnifyingGlassMinus.svg';
import iconMagnifyingGlassPlus from './svg/iconMagnifyingGlassPlus.svg';
import iconBatteryCharging from './svg/iconBatteryCharging.svg';
import iconBatteryChargingVertical from './svg/iconBatteryChargingVertical.svg';
import iconBatteryEmpty from './svg/iconBatteryEmpty.svg';
import iconBatteryFull from './svg/iconBatteryFull.svg';
import iconBatteryHigh from './svg/iconBatteryHigh.svg';
import iconBatteryLow from './svg/iconBatteryLow.svg';
import iconBatteryMedium from './svg/iconBatteryMedium.svg';
import iconBatteryPlus from './svg/iconBatteryPlus.svg';
import iconBatteryWarning from './svg/iconBatteryWarning.svg';
import iconBatteryWarningVertical from './svg/iconBatteryWarningVertical.svg';
import iconPlug from './svg/iconPlug.svg';
import iconPlugs from './svg/iconPlugs.svg';
import iconPlugsConnected from './svg/iconPlugsConnected.svg';
import iconHardDrive from './svg/iconHardDrive.svg';
import iconHardDrives from './svg/iconHardDrives.svg';
import iconLink from './svg/iconLink.svg';
import iconLinkBreak from './svg/iconLinkBreak.svg';
import iconLinkSimple from './svg/iconLinkSimple.svg';
import iconLinkSimpleBreak from './svg/iconLinkSimpleBreak.svg';
import iconLinkSimpleHorizontal from './svg/iconLinkSimpleHorizontal.svg';
import iconLinkSimpleHorizontalBreak from './svg/iconLinkSimpleHorizontalBreak.svg';
import iconMonitor from './svg/iconMonitor.svg';
import iconMonitorPlay from './svg/iconMonitorPlay.svg';
import iconMouse from './svg/iconMouse.svg';
import iconMouseSimple from './svg/iconMouseSimple.svg';
import iconSignIn from './svg/iconSignIn.svg';
import iconSignOut from './svg/iconSignOut.svg';
import iconSpinner from './svg/iconSpinner.svg';
import iconSpinnerGap from './svg/iconSpinnerGap.svg';
import iconBrowser from './svg/iconBrowser.svg';
import iconBrowsers from './svg/iconBrowsers.svg';
import iconAppWindow from './svg/iconAppWindow.svg';
import iconBackspace from './svg/iconBackspace.svg';
import iconCommand from './svg/iconCommand.svg';
import iconComputerTower from './svg/iconComputerTower.svg';
import iconCursor from './svg/iconCursor.svg';
import iconLaptop from './svg/iconLaptop.svg';
import iconFlashlight from './svg/iconFlashlight.svg';
import iconGauge from './svg/iconGauge.svg';
import iconPower from './svg/iconPower.svg';
import iconScan from './svg/iconScan.svg';
import iconQrCode from './svg/iconQrCode.svg';
import iconSwap from './svg/iconSwap.svg';
import iconNotification from './svg/iconNotification.svg';
import iconRadioButton from './svg/iconRadioButton.svg';
import iconNut from './svg/iconNut.svg';
import iconGearSix from './svg/iconGearSix.svg';
import iconSimCard from './svg/iconSimCard.svg';
import iconVibrate from './svg/iconVibrate.svg';
import iconWrench from './svg/iconWrench.svg';
import iconWifiHigh from './svg/iconWifiHigh.svg';
import iconWifiLow from './svg/iconWifiLow.svg';
import iconWifiMedium from './svg/iconWifiMedium.svg';
import iconWifiNone from './svg/iconWifiNone.svg';
import iconWifiSlash from './svg/iconWifiSlash.svg';
import iconWifiX from './svg/iconWifiX.svg';
import iconLightning from './svg/iconLightning.svg';
import iconLightningSlash from './svg/iconLightningSlash.svg';
import iconKeyReturn from './svg/iconKeyReturn.svg';
import iconKeyboard from './svg/iconKeyboard.svg';
import iconCheckCircle from './svg/iconCheckCircle.svg';
import iconCheckSquareFilled from './svg/iconCheckSquareFilled.svg';
import iconCheckSquareEmpty from './svg/iconCheckSquareEmpty.svg';
import iconCheckSquareOffset from './svg/iconCheckSquareOffset.svg';
import iconChecks from './svg/iconChecks.svg';
import iconCloudCheck from './svg/iconCloudCheck.svg';
import iconCloudSlash from './svg/iconCloudSlash.svg';
import iconCloudArrowDown from './svg/iconCloudArrowDown.svg';
import iconCloudArrowUp from './svg/iconCloudArrowUp.svg';
import iconDesktop from './svg/iconDesktop.svg';
import iconDesktopTower from './svg/iconDesktopTower.svg';
import iconDownload from './svg/iconDownload.svg';
import iconDownloadSimple from './svg/iconDownloadSimple.svg';
import iconUpload from './svg/iconUpload.svg';
import iconUploadSimple from './svg/iconUploadSimple.svg';
import iconDeviceMobile from './svg/iconDeviceMobile.svg';
import iconDeviceMobileCamera from './svg/iconDeviceMobileCamera.svg';
import iconDeviceMobileSpeaker from './svg/iconDeviceMobileSpeaker.svg';
import iconDeviceTablet from './svg/iconDeviceTablet.svg';
import iconDeviceTabletCamera from './svg/iconDeviceTabletCamera.svg';
import iconDeviceTabletSpeaker from './svg/iconDeviceTabletSpeaker.svg';
import iconDotsNine from './svg/iconDotsNine.svg';
import iconDotsSix from './svg/iconDotsSix.svg';
import iconDotsSixVertical from './svg/iconDotsSixVertical.svg';
import iconDotsThree from './svg/iconDotsThree.svg';
import iconDotsThreeCircle from './svg/iconDotsThreeCircle.svg';
import iconDotsThreeCircleVertical from './svg/iconDotsThreeCircleVertical.svg';
import iconDotsThreeOutline from './svg/iconDotsThreeOutline.svg';
import iconDotsThreeOutlineVertical from './svg/iconDotsThreeOutlineVertical.svg';
import iconWarning from './svg/iconWarning.svg';
import iconMagicWand from './svg/iconMagicWand.svg';
import iconMarkerCircle from './svg/iconMarkerCircle.svg';
import iconEyedropper from './svg/iconEyedropper.svg';
import iconIntersect from './svg/iconIntersect.svg';
import iconFlowArrow from './svg/iconFlowArrow.svg';
import iconGradient from './svg/iconGradient.svg';
import iconDiamondsFour from './svg/iconDiamondsFour.svg';
import iconDropHalf from './svg/iconDropHalf.svg';
import iconDropHalfBottom from './svg/iconDropHalfBottom.svg';
import iconEraser from './svg/iconEraser.svg';
import iconRuler from './svg/iconRuler.svg';
import iconScissors from './svg/iconScissors.svg';
import iconBezierCurve from './svg/iconBezierCurve.svg';
import iconBoundingBox from './svg/iconBoundingBox.svg';
import iconSwatches from './svg/iconSwatches.svg';
import iconVignette from './svg/iconVignette.svg';
import iconAlignBottom from './svg/iconAlignBottom.svg';
import iconAlignBottomSimple from './svg/iconAlignBottomSimple.svg';
import iconAlignCenterHorizontal from './svg/iconAlignCenterHorizontal.svg';
import iconAlignCenterHorizontalSimple from './svg/iconAlignCenterHorizontalSimple.svg';
import iconAlignCenterVertical from './svg/iconAlignCenterVertical.svg';
import iconAlignCenterVerticalSimple from './svg/iconAlignCenterVerticalSimple.svg';
import iconAlignLeft from './svg/iconAlignLeft.svg';
import iconAlignLeftSimple from './svg/iconAlignLeftSimple.svg';
import iconAlignRight from './svg/iconAlignRight.svg';
import iconAlignRightSimple from './svg/iconAlignRightSimple.svg';
import iconAlignTop from './svg/iconAlignTop.svg';
import iconAlignTopSimple from './svg/iconAlignTopSimple.svg';
import iconEyeSlash from './svg/iconEyeSlash.svg';
import iconEye from './svg/iconEye.svg';
import iconEyeClosed from './svg/iconEyeClosed.svg';
import iconSelection from './svg/iconSelection.svg';
import iconSelectionAll from './svg/iconSelectionAll.svg';
import iconSelectionBackground from './svg/iconSelectionBackground.svg';
import iconSelectionForeground from './svg/iconSelectionForeground.svg';
import iconSelectionInverse from './svg/iconSelectionInverse.svg';
import iconSelectionPlus from './svg/iconSelectionPlus.svg';
import iconSelectionSlash from './svg/iconSelectionSlash.svg';
import iconCrop from './svg/iconCrop.svg';
import iconRectangle from './svg/iconRectangle.svg';
import iconSquare from './svg/iconSquare.svg';
import iconTriangle from './svg/iconTriangle.svg';
import iconHexagon from './svg/iconHexagon.svg';
import iconCylinder from './svg/iconCylinder.svg';
import iconCube from './svg/iconCube.svg';
import iconCircle from './svg/iconCircle.svg';
import iconCircleDashed from './svg/iconCircleDashed.svg';
import iconCircleHalf from './svg/iconCircleHalf.svg';
import iconCircleHalfTilt from './svg/iconCircleHalfTilt.svg';
import iconCircleNotch from './svg/iconCircleNotch.svg';
import iconCirclesFour from './svg/iconCirclesFour.svg';
import iconCirclesThree from './svg/iconCirclesThree.svg';
import iconCirclesThreePlus from './svg/iconCirclesThreePlus.svg';
import iconLineSegment from './svg/iconLineSegment.svg';
import iconLineSegments from './svg/iconLineSegments.svg';
import iconLayout from './svg/iconLayout.svg';
import iconGridFour from './svg/iconGridFour.svg';
import iconRows from './svg/iconRows.svg';
import iconSidebar from './svg/iconSidebar.svg';
import iconSidebarSimple from './svg/iconSidebarSimple.svg';
import iconSquareHalf from './svg/iconSquareHalf.svg';
import iconColumns from './svg/iconColumns.svg';
import iconPlaceholder from './svg/iconPlaceholder.svg';
import iconPolygon from './svg/iconPolygon.svg';
import iconSquareHalfBottom from './svg/iconSquareHalfBottom.svg';
import iconSquaresFour from './svg/iconSquaresFour.svg';
import iconStack from './svg/iconStack.svg';
import iconStackSimple from './svg/iconStackSimple.svg';
import iconHighlighterCircle from './svg/iconHighlighterCircle.svg';
import iconPaintBrushHousehold from './svg/iconPaintBrushHousehold.svg';
import iconPaintBucket from './svg/iconPaintBucket.svg';
import iconPaintRoller from './svg/iconPaintRoller.svg';
import iconPaintBrush from './svg/iconPaintBrush.svg';
import iconPencilCircle from './svg/iconPencilCircle.svg';
import iconPenNib from './svg/iconPenNib.svg';
import iconPenNibStraight from './svg/iconPenNibStraight.svg';
import iconVideoCamera from './svg/iconVideoCamera.svg';
import iconVideoCameraSlash from './svg/iconVideoCameraSlash.svg';
import iconArticle from './svg/iconArticle.svg';
import iconArticleMedium from './svg/iconArticleMedium.svg';
import iconArticleNyTimes from './svg/iconArticleNyTimes.svg';
import iconCamera from './svg/iconCamera.svg';
import iconCameraRotate from './svg/iconCameraRotate.svg';
import iconCameraSlash from './svg/iconCameraSlash.svg';
import iconEject from './svg/iconEject.svg';
import iconEjectSimple from './svg/iconEjectSimple.svg';
import iconFilmSlate from './svg/iconFilmSlate.svg';
import iconFilmStrip from './svg/iconFilmStrip.svg';
import iconFilmScript from './svg/iconFilmScript.svg';
import iconMediaMiscClosedCaptioning from './svg/iconMediaMiscClosedCaptioning.svg';
import iconCopyleft from './svg/iconCopyleft.svg';
import iconCopyright from './svg/iconCopyright.svg';
import iconCornersIn from './svg/iconCornersIn.svg';
import iconFrameCorners from './svg/iconFrameCorners.svg';
import iconCornersOut from './svg/iconCornersOut.svg';
import iconMediaMiscDisc from './svg/iconMediaMiscDisc.svg';
import iconEar from './svg/iconEar.svg';
import iconEarSlash from './svg/iconEarSlash.svg';
import iconFaders from './svg/iconFaders.svg';
import iconFadersHorizontal from './svg/iconFadersHorizontal.svg';
import iconImage from './svg/iconImage.svg';
import iconImageSquare from './svg/iconImageSquare.svg';
import iconCastAirplay from './svg/iconCastAirplay.svg';
import iconScreencast from './svg/iconScreencast.svg';
import iconTelevision from './svg/iconTelevision.svg';
import iconTelevisionSimple from './svg/iconTelevisionSimple.svg';
import iconHeadphones from './svg/iconHeadphones.svg';
import iconHeadset from './svg/iconHeadset.svg';
import iconMicrophone from './svg/iconMicrophone.svg';
import iconMicrophoneSlash from './svg/iconMicrophoneSlash.svg';
import iconMicrophoneStage from './svg/iconMicrophoneStage.svg';
import iconMusicNote from './svg/iconMusicNote.svg';
import iconMusicNoteSimple from './svg/iconMusicNoteSimple.svg';
import iconMusicNotes from './svg/iconMusicNotes.svg';
import iconMusicNotesPlus from './svg/iconMusicNotesPlus.svg';
import iconMusicNotesSimple from './svg/iconMusicNotesSimple.svg';
import iconWaveSawtooth from './svg/iconWaveSawtooth.svg';
import iconWaveSine from './svg/iconWaveSine.svg';
import iconWaveSquare from './svg/iconWaveSquare.svg';
import iconWaveTriangle from './svg/iconWaveTriangle.svg';
import iconSliders from './svg/iconSliders.svg';
import iconSlidersHorizontal from './svg/iconSlidersHorizontal.svg';
import iconPlay from './svg/iconPlay.svg';
import iconPause from './svg/iconPause.svg';
import iconRecord from './svg/iconRecord.svg';
import iconRepeat from './svg/iconRepeat.svg';
import iconRepeatOnce from './svg/iconRepeatOnce.svg';
import iconShuffle from './svg/iconShuffle.svg';
import iconShuffleAngular from './svg/iconShuffleAngular.svg';
import iconShuffleSimple from './svg/iconShuffleSimple.svg';
import iconSkipBack from './svg/iconSkipBack.svg';
import iconSkipForward from './svg/iconSkipForward.svg';
import iconStop from './svg/iconStop.svg';
import iconStopCircle from './svg/iconStopCircle.svg';
import iconPauseCircle from './svg/iconPauseCircle.svg';
import iconPlaylist from './svg/iconPlaylist.svg';
import iconQueue from './svg/iconQueue.svg';
import iconSpeakerHigh from './svg/iconSpeakerHigh.svg';
import iconSpeakerLow from './svg/iconSpeakerLow.svg';
import iconSpeakerNone from './svg/iconSpeakerNone.svg';
import iconSpeakerSimpleHigh from './svg/iconSpeakerSimpleHigh.svg';
import iconSpeakerSimpleLow from './svg/iconSpeakerSimpleLow.svg';
import iconSpeakerSimpleNone from './svg/iconSpeakerSimpleNone.svg';
import iconSpeakerSimpleSlash from './svg/iconSpeakerSimpleSlash.svg';
import iconSpeakerSimpleX from './svg/iconSpeakerSimpleX.svg';
import iconSpeakerSlash from './svg/iconSpeakerSlash.svg';
import iconSpeakerX from './svg/iconSpeakerX.svg';
import iconEqualizer from './svg/iconEqualizer.svg';
import iconPianoKeys from './svg/iconPianoKeys.svg';
import iconPictureInPicture from './svg/iconPictureInPicture.svg';
import iconWebcam from './svg/iconWebcam.svg';
import iconAperture from './svg/iconAperture.svg';
import iconChat from './svg/iconChat.svg';
import iconChatCentered from './svg/iconChatCentered.svg';
import iconChatCenteredDots from './svg/iconChatCenteredDots.svg';
import iconChatCenteredText from './svg/iconChatCenteredText.svg';
import iconChatCircle from './svg/iconChatCircle.svg';
import iconChatCircleDots from './svg/iconChatCircleDots.svg';
import iconChatCircleText from './svg/iconChatCircleText.svg';
import iconChatDots from './svg/iconChatDots.svg';
import iconChatTeardrop from './svg/iconChatTeardrop.svg';
import iconChatTeardropDots from './svg/iconChatTeardropDots.svg';
import iconChatTeardropText from './svg/iconChatTeardropText.svg';
import iconChatText from './svg/iconChatText.svg';
import iconChats from './svg/iconChats.svg';
import iconChatsTeardrop from './svg/iconChatsTeardrop.svg';
import iconChatsCircle from './svg/iconChatsCircle.svg';
import iconShare from './svg/iconShare.svg';
import iconShareNetwork from './svg/iconShareNetwork.svg';
import iconEnvelope from './svg/iconEnvelope.svg';
import iconEnvelopeOpen from './svg/iconEnvelopeOpen.svg';
import iconEnvelopeSimple from './svg/iconEnvelopeSimple.svg';
import iconEnvelopeSimpleOpen from './svg/iconEnvelopeSimpleOpen.svg';
import iconPaperPlane from './svg/iconPaperPlane.svg';
import iconPaperPlaneRight from './svg/iconPaperPlaneRight.svg';
import iconPaperPlaneTilt from './svg/iconPaperPlaneTilt.svg';
import iconAsterisk from './svg/iconAsterisk.svg';
import iconAsteriskSimple from './svg/iconAsteriskSimple.svg';
import iconHash from './svg/iconHash.svg';
import iconHashStraight from './svg/iconHashStraight.svg';
import iconPhoneDisconnect from './svg/iconPhoneDisconnect.svg';
import iconPhoneSlash from './svg/iconPhoneSlash.svg';
import iconMegaphoneSimple from './svg/iconMegaphoneSimple.svg';
import iconMegaphone from './svg/iconMegaphone.svg';
import iconRss from './svg/iconRss.svg';
import iconRssSimple from './svg/iconRssSimple.svg';
import iconBroadcast from './svg/iconBroadcast.svg';
import iconAddressBook from './svg/iconAddressBook.svg';
import iconPeace from './svg/iconPeace.svg';
import iconQuotes from './svg/iconQuotes.svg';
import iconSticker from './svg/iconSticker.svg';
import iconRadio from './svg/iconRadio.svg';
import iconTranslate from './svg/iconTranslate.svg';
import iconVoicemail from './svg/iconVoicemail.svg';
import iconYinYang from './svg/iconYinYang.svg';
import iconExport from './svg/iconExport.svg';
import iconStarHalf from './svg/iconStarHalf.svg';
import iconStar from './svg/iconStar.svg';
import iconHeart from './svg/iconHeart.svg';
import iconScales from './svg/iconScales.svg';
import iconStorefront from './svg/iconStorefront.svg';
import iconTShirt from './svg/iconTShirt.svg';
import iconTag from './svg/iconTag.svg';
import iconTagChevron from './svg/iconTagChevron.svg';
import iconTagSimple from './svg/iconTagSimple.svg';
import iconReceipt from './svg/iconReceipt.svg';
import iconRug from './svg/iconRug.svg';
import iconPackage from './svg/iconPackage.svg';
import iconTrademarkRegistered from './svg/iconTrademarkRegistered.svg';
import iconWallet from './svg/iconWallet.svg';
import iconGift from './svg/iconGift.svg';
import iconBinoculars from './svg/iconBinoculars.svg';
import iconArmchair from './svg/iconArmchair.svg';
import iconBalloon from './svg/iconBalloon.svg';
import iconBarcode from './svg/iconBarcode.svg';
import iconBathtub from './svg/iconBathtub.svg';
import iconCoatHanger from './svg/iconCoatHanger.svg';
import iconFactory from './svg/iconFactory.svg';
import iconLadder from './svg/iconLadder.svg';
import iconLadderSimple from './svg/iconLadderSimple.svg';
import iconLamp from './svg/iconLamp.svg';
import iconBag from './svg/iconBag.svg';
import iconBagSimple from './svg/iconBagSimple.svg';
import iconShoppingBag from './svg/iconShoppingBag.svg';
import iconShoppingBagOpen from './svg/iconShoppingBagOpen.svg';
import iconHandbag from './svg/iconHandbag.svg';
import iconHandbagSimple from './svg/iconHandbagSimple.svg';
import iconTote from './svg/iconTote.svg';
import iconToteSimple from './svg/iconToteSimple.svg';
import iconBackpack from './svg/iconBackpack.svg';
import iconCoin from './svg/iconCoin.svg';
import iconCoinVertical from './svg/iconCoinVertical.svg';
import iconCoins from './svg/iconCoins.svg';
import iconCreditCard from './svg/iconCreditCard.svg';
import iconMoney from './svg/iconMoney.svg';
import iconMartini from './svg/iconMartini.svg';
import iconHamburger from './svg/iconHamburger.svg';
import iconWine from './svg/iconWine.svg';
import iconCookie from './svg/iconCookie.svg';
import iconEgg from './svg/iconEgg.svg';
import iconEggCrack from './svg/iconEggCrack.svg';
import iconPizza from './svg/iconPizza.svg';
import iconPopcorn from './svg/iconPopcorn.svg';
import iconCoffee from './svg/iconCoffee.svg';
import iconBrandy from './svg/iconBrandy.svg';
import iconBeerBottle from './svg/iconBeerBottle.svg';
import iconKnife from './svg/iconKnife.svg';
import iconForkKnife from './svg/iconForkKnife.svg';
import iconCurrencyBtc from './svg/iconCurrencyBtc.svg';
import iconCurrencyCircleDollar from './svg/iconCurrencyCircleDollar.svg';
import iconCurrencyDollar from './svg/iconCurrencyDollar.svg';
import iconCurrencyDollarSimple from './svg/iconCurrencyDollarSimple.svg';
import iconCurrencyEth from './svg/iconCurrencyEth.svg';
import iconCurrencyEur from './svg/iconCurrencyEur.svg';
import iconCurrencyGbp from './svg/iconCurrencyGbp.svg';
import iconCurrencyInr from './svg/iconCurrencyInr.svg';
import iconCurrencyJpy from './svg/iconCurrencyJpy.svg';
import iconCurrencyKrw from './svg/iconCurrencyKrw.svg';
import iconCurrencyKzt from './svg/iconCurrencyKzt.svg';
import iconCurrencyNgn from './svg/iconCurrencyNgn.svg';
import iconCurrencyRub from './svg/iconCurrencyRub.svg';
import iconPercent from './svg/iconPercent.svg';
import iconPlus from './svg/iconPlus.svg';
import iconPlusCircle from './svg/iconPlusCircle.svg';
import iconPlusMinus from './svg/iconPlusMinus.svg';
import iconRadical from './svg/iconRadical.svg';
import iconDivide from './svg/iconDivide.svg';
import iconEquals from './svg/iconEquals.svg';
import iconFunction from './svg/iconFunction.svg';
import iconMathOperations from './svg/iconMathOperations.svg';
import iconMinus from './svg/iconMinus.svg';
import iconMinusCircle from './svg/iconMinusCircle.svg';
import iconXCircle from './svg/iconXCircle.svg';
import iconXSquare from './svg/iconXSquare.svg';
import iconTable from './svg/iconTable.svg';
import iconGraph from './svg/iconGraph.svg';
import iconInfinity from './svg/iconInfinity.svg';
import iconBank from './svg/iconBank.svg';
import iconCalculator from './svg/iconCalculator.svg';
import iconChartBar from './svg/iconChartBar.svg';
import iconChartBarHorizontal from './svg/iconChartBarHorizontal.svg';
import iconChartLine from './svg/iconChartLine.svg';
import iconChartLineUp from './svg/iconChartLineUp.svg';
import iconChartPie from './svg/iconChartPie.svg';
import iconTrendDown from './svg/iconTrendDown.svg';
import iconTrendUp from './svg/iconTrendUp.svg';
import iconNumberCircleZero from './svg/iconNumberCircleZero.svg';
import iconNumberCircleOne from './svg/iconNumberCircleOne.svg';
import iconNumberCircleThree from './svg/iconNumberCircleThree.svg';
import iconNumberCircleFour from './svg/iconNumberCircleFour.svg';
import iconNumberCircleFive from './svg/iconNumberCircleFive.svg';
import iconNumberCircleSix from './svg/iconNumberCircleSix.svg';
import iconNumberCircleSeven from './svg/iconNumberCircleSeven.svg';
import iconNumberCircleEight from './svg/iconNumberCircleEight.svg';
import iconNumberCircleNine from './svg/iconNumberCircleNine.svg';
import iconNumberZero from './svg/iconNumberZero.svg';
import iconNumberOne from './svg/iconNumberOne.svg';
import iconNumberTwo from './svg/iconNumberTwo.svg';
import iconNumberThree from './svg/iconNumberThree.svg';
import iconNumberFour from './svg/iconNumberFour.svg';
import iconNumberFive from './svg/iconNumberFive.svg';
import iconNumberSix from './svg/iconNumberSix.svg';
import iconNumberSeven from './svg/iconNumberSeven.svg';
import iconNumberNine from './svg/iconNumberNine.svg';
import iconNumberSquareZero from './svg/iconNumberSquareZero.svg';
import iconNumberSquareOne from './svg/iconNumberSquareOne.svg';
import iconNumberSquareThree from './svg/iconNumberSquareThree.svg';
import iconNumberSquareFour from './svg/iconNumberSquareFour.svg';
import iconNumberSquareFive from './svg/iconNumberSquareFive.svg';
import iconNumberSquareSix from './svg/iconNumberSquareSix.svg';
import iconNumberSquareSeven from './svg/iconNumberSquareSeven.svg';
import iconNumberSquareEight from './svg/iconNumberSquareEight.svg';
import iconNumberSquareNine from './svg/iconNumberSquareNine.svg';
import iconAirplane from './svg/iconAirplane.svg';
import iconAirplaneLanding from './svg/iconAirplaneLanding.svg';
import iconAirplaneTakeoff from './svg/iconAirplaneTakeoff.svg';
import iconAirplaneTilt from './svg/iconAirplaneTilt.svg';
import iconGlobe from './svg/iconGlobe.svg';
import iconGlobeHemisphereEast from './svg/iconGlobeHemisphereEast.svg';
import iconGlobeHemisphereWest from './svg/iconGlobeHemisphereWest.svg';
import iconGlobeSimple from './svg/iconGlobeSimple.svg';
import iconGlobeStand from './svg/iconGlobeStand.svg';
import iconTrafficCone from './svg/iconTrafficCone.svg';
import iconBarricade from './svg/iconBarricade.svg';
import iconTrafficSignal from './svg/iconTrafficSignal.svg';
import iconSignpost from './svg/iconSignpost.svg';
import iconHouseLine from './svg/iconHouseLine.svg';
import iconHouseSimple from './svg/iconHouseSimple.svg';
import iconMapPin from './svg/iconMapPin.svg';
import iconMapPinLine from './svg/iconMapPinLine.svg';
import iconMapTrifold from './svg/iconMapTrifold.svg';
import iconNavigationArrow from './svg/iconNavigationArrow.svg';
import iconPath from './svg/iconPath.svg';
import iconCompass from './svg/iconCompass.svg';
import iconCrosshair from './svg/iconCrosshair.svg';
import iconCrosshairSimple from './svg/iconCrosshairSimple.svg';
import iconAnchor from './svg/iconAnchor.svg';
import iconAnchorSimple from './svg/iconAnchorSimple.svg';
import iconFlag from './svg/iconFlag.svg';
import iconFlagBanner from './svg/iconFlagBanner.svg';
import iconFlagCheckered from './svg/iconFlagCheckered.svg';
import iconRocket from './svg/iconRocket.svg';
import iconRocketLaunch from './svg/iconRocketLaunch.svg';
import iconTruck from './svg/iconTruck.svg';
import iconJeep from './svg/iconJeep.svg';
import iconPoliceCar from './svg/iconPoliceCar.svg';
import iconCar from './svg/iconCar.svg';
import iconCarSimple from './svg/iconCarSimple.svg';
import iconBicycle from './svg/iconBicycle.svg';
import iconTrainSimple from './svg/iconTrainSimple.svg';
import iconTrain from './svg/iconTrain.svg';
import iconBoat from './svg/iconBoat.svg';
import iconSuitcase from './svg/iconSuitcase.svg';
import iconSuitcaseSimple from './svg/iconSuitcaseSimple.svg';
import iconDoor from './svg/iconDoor.svg';
import iconGasPump from './svg/iconGasPump.svg';
import iconThermometer from './svg/iconThermometer.svg';
import iconThermometerCold from './svg/iconThermometerCold.svg';
import iconThermometerHot from './svg/iconThermometerHot.svg';
import iconThermometerSimple from './svg/iconThermometerSimple.svg';
import iconMoonStars from './svg/iconMoonStars.svg';
import iconMountains from './svg/iconMountains.svg';
import iconPlanet from './svg/iconPlanet.svg';
import iconRainbow from './svg/iconRainbow.svg';
import iconSnowflake from './svg/iconSnowflake.svg';
import iconSparkle from './svg/iconSparkle.svg';
import iconStarFour from './svg/iconStarFour.svg';
import iconSun from './svg/iconSun.svg';
import iconSunDim from './svg/iconSunDim.svg';
import iconSunHorizon from './svg/iconSunHorizon.svg';
import iconWind from './svg/iconWind.svg';
import iconBird from './svg/iconBird.svg';
import iconButterfly from './svg/iconButterfly.svg';
import iconDog from './svg/iconDog.svg';
import iconFish from './svg/iconFish.svg';
import iconFishSimple from './svg/iconFishSimple.svg';
import iconCat from './svg/iconCat.svg';
import iconPawPrint from './svg/iconPawPrint.svg';
import iconAtom from './svg/iconAtom.svg';
import iconTree from './svg/iconTree.svg';
import iconTreeEvergreen from './svg/iconTreeEvergreen.svg';
import iconCactus from './svg/iconCactus.svg';
import iconFlower from './svg/iconFlower.svg';
import iconFlowerLotus from './svg/iconFlowerLotus.svg';
import iconLeaf from './svg/iconLeaf.svg';
import iconCloudLightning from './svg/iconCloudLightning.svg';
import iconCloudRain from './svg/iconCloudRain.svg';
import iconCloudSnow from './svg/iconCloudSnow.svg';
import iconCloudSun from './svg/iconCloudSun.svg';
import iconCloud from './svg/iconCloud.svg';
import iconCloudFog from './svg/iconCloudFog.svg';
import iconFireSimple from './svg/iconFireSimple.svg';
import iconDrop from './svg/iconDrop.svg';
import iconFire from './svg/iconFire.svg';
import iconCampfire from './svg/iconCampfire.svg';
import iconUserCircleGear from './svg/iconUserCircleGear.svg';
import iconUserCircle from './svg/iconUserCircle.svg';
import iconUserFocus from './svg/iconUserFocus.svg';
import iconUserGear from './svg/iconUserGear.svg';
import iconUserList from './svg/iconUserList.svg';
import iconUserMinus from './svg/iconUserMinus.svg';
import iconUserPlus from './svg/iconUserPlus.svg';
import iconUserRectangle from './svg/iconUserRectangle.svg';
import iconUserSquare from './svg/iconUserSquare.svg';
import iconUserSwitch from './svg/iconUserSwitch.svg';
import iconUsersFour from './svg/iconUsersFour.svg';
import iconUsersThree from './svg/iconUsersThree.svg';
import iconIdentificationBadge from './svg/iconIdentificationBadge.svg';
import iconIdentificationCard from './svg/iconIdentificationCard.svg';
import iconGenderFemale from './svg/iconGenderFemale.svg';
import iconGenderIntersex from './svg/iconGenderIntersex.svg';
import iconGenderMale from './svg/iconGenderMale.svg';
import iconGenderNeuter from './svg/iconGenderNeuter.svg';
import iconGenderNonbinary from './svg/iconGenderNonbinary.svg';
import iconGenderTransgender from './svg/iconGenderTransgender.svg';
import iconHandEye from './svg/iconHandEye.svg';
import iconHand from './svg/iconHand.svg';
import iconHandGrabbing from './svg/iconHandGrabbing.svg';
import iconHandPalm from './svg/iconHandPalm.svg';
import iconHandPointing from './svg/iconHandPointing.svg';
import iconHandsClapping from './svg/iconHandsClapping.svg';
import iconHandshake from './svg/iconHandshake.svg';
import iconSmiley from './svg/iconSmiley.svg';
import iconSmileyBlank from './svg/iconSmileyBlank.svg';
import iconSmileyMeh from './svg/iconSmileyMeh.svg';
import iconSmileyNervous from './svg/iconSmileyNervous.svg';
import iconSmileySad from './svg/iconSmileySad.svg';
import iconSmileyWink from './svg/iconSmileyWink.svg';
import iconSmileyXEyes from './svg/iconSmileyXEyes.svg';
import iconBaby from './svg/iconBaby.svg';
import iconPerson from './svg/iconPerson.svg';
import iconWheelchair from './svg/iconWheelchair.svg';
import iconPersonSimpleRun from './svg/iconPersonSimpleRun.svg';
import iconPersonSimpleWalk from './svg/iconPersonSimpleWalk.svg';
import iconShield from './svg/iconShield.svg';
import iconShieldCheck from './svg/iconShieldCheck.svg';
import iconShieldCheckered from './svg/iconShieldCheckered.svg';
import iconShieldChevron from './svg/iconShieldChevron.svg';
import iconShieldPlus from './svg/iconShieldPlus.svg';
import iconShieldSlash from './svg/iconShieldSlash.svg';
import iconShieldStar from './svg/iconShieldStar.svg';
import iconShieldWarning from './svg/iconShieldWarning.svg';
import iconLock from './svg/iconLock.svg';
import iconLockKey from './svg/iconLockKey.svg';
import iconLockKeyOpen from './svg/iconLockKeyOpen.svg';
import iconLockLaminated from './svg/iconLockLaminated.svg';
import iconLockLaminatedOpen from './svg/iconLockLaminatedOpen.svg';
import iconLockOpen from './svg/iconLockOpen.svg';
import iconLockSimple from './svg/iconLockSimple.svg';
import iconLockSimpleOpen from './svg/iconLockSimpleOpen.svg';
import iconCircleWavy from './svg/iconCircleWavy.svg';
import iconCircleWavyCheck from './svg/iconCircleWavyCheck.svg';
import iconCircleWavyQuestion from './svg/iconCircleWavyQuestion.svg';
import iconCircleWavyWarning from './svg/iconCircleWavyWarning.svg';
import iconProhibit from './svg/iconProhibit.svg';
import iconProhibitInset from './svg/iconProhibitInset.svg';
import iconQuestion from './svg/iconQuestion.svg';
import iconInfo from './svg/iconInfo.svg';
import iconDetective from './svg/iconDetective.svg';
import iconKey from './svg/iconKey.svg';
import iconVault from './svg/iconVault.svg';
import iconWall from './svg/iconWall.svg';
import iconPassword from './svg/iconPassword.svg';
import iconGhost from './svg/iconGhost.svg';
import iconAlien from './svg/iconAlien.svg';
import iconConfetti from './svg/iconConfetti.svg';
import iconCrown from './svg/iconCrown.svg';
import iconHorse from './svg/iconHorse.svg';
import iconCrownSimple from './svg/iconCrownSimple.svg';
import iconMaskHappy from './svg/iconMaskHappy.svg';
import iconMaskSad from './svg/iconMaskSad.svg';
import iconMedal from './svg/iconMedal.svg';
import iconParachute from './svg/iconParachute.svg';
import iconPinwheel from './svg/iconPinwheel.svg';
import iconStrategy from './svg/iconStrategy.svg';
import iconSword from './svg/iconSword.svg';
import iconFinnTheHuman from './svg/iconFinnTheHuman.svg';
import iconPuzzlePiece from './svg/iconPuzzlePiece.svg';
import iconTarget from './svg/iconTarget.svg';
import iconDiceFive from './svg/iconDiceFive.svg';
import iconDiceFour from './svg/iconDiceFour.svg';
import iconDiceOne from './svg/iconDiceOne.svg';
import iconDiceSix from './svg/iconDiceSix.svg';
import iconDiceThree from './svg/iconDiceThree.svg';
import iconDiceTwo from './svg/iconDiceTwo.svg';
import iconHeartStraight from './svg/iconHeartStraight.svg';
import iconHeartStraightBreak from './svg/iconHeartStraightBreak.svg';
import iconBasketball from './svg/iconBasketball.svg';
import iconBaseball from './svg/iconBaseball.svg';
import iconVolleyball from './svg/iconVolleyball.svg';
import iconSoccerBall from './svg/iconSoccerBall.svg';
import iconFootball from './svg/iconFootball.svg';
import iconPokerChip from './svg/iconPokerChip.svg';
import iconClub from './svg/iconClub.svg';
import iconSpade from './svg/iconSpade.svg';
import iconGamesRewards from './svg/iconGamesRewards.svg';
import iconAndroidLogo from './svg/iconAndroidLogo.svg';
import iconAngularLogo from './svg/iconAngularLogo.svg';
import iconAppStoreLogo from './svg/iconAppStoreLogo.svg';
import iconBehanceLogo from './svg/iconBehanceLogo.svg';
import iconCodepenLogo from './svg/iconCodepenLogo.svg';
import iconCodesandboxLogo from './svg/iconCodesandboxLogo.svg';
import iconDribbbleLogo from './svg/iconDribbbleLogo.svg';
import iconFacebookLogo from './svg/iconFacebookLogo.svg';
import iconFigmaLogo from './svg/iconFigmaLogo.svg';
import iconFramerLogo from './svg/iconFramerLogo.svg';
import iconGitlabLogo from './svg/iconGitlabLogo.svg';
import iconGitlabLogoSimple from './svg/iconGitlabLogoSimple.svg';
import iconGoogleChromeLogo from './svg/iconGoogleChromeLogo.svg';
import iconGoogleLogo from './svg/iconGoogleLogo.svg';
import iconGooglePhotosLogo from './svg/iconGooglePhotosLogo.svg';
import iconGooglePlayLogo from './svg/iconGooglePlayLogo.svg';
import iconGooglePodcastsLogo from './svg/iconGooglePodcastsLogo.svg';
import iconInstagramLogo from './svg/iconInstagramLogo.svg';
import iconLinkedinLogo from './svg/iconLinkedinLogo.svg';
import iconMediumLogo from './svg/iconMediumLogo.svg';
import iconMessengerLogo from './svg/iconMessengerLogo.svg';
import iconMicrosoftExcelLogo from './svg/iconMicrosoftExcelLogo.svg';
import iconMicrosoftPowerpointLogo from './svg/iconMicrosoftPowerpointLogo.svg';
import iconMicrosoftWordLogo from './svg/iconMicrosoftWordLogo.svg';
import iconNyTimesLogo from './svg/iconNyTimesLogo.svg';
import iconPinterestLogo from './svg/iconPinterestLogo.svg';
import iconSketchLogo from './svg/iconSketchLogo.svg';
import iconSnapchatLogo from './svg/iconSnapchatLogo.svg';
import iconSquareLogo from './svg/iconSquareLogo.svg';
import iconStackOverflowLogo from './svg/iconStackOverflowLogo.svg';
import iconStripeLogo from './svg/iconStripeLogo.svg';
import iconTelegramLogo from './svg/iconTelegramLogo.svg';
import iconTiktokLogo from './svg/iconTiktokLogo.svg';
import iconTwitchLogo from './svg/iconTwitchLogo.svg';
import iconTwitterLogo from './svg/iconTwitterLogo.svg';
import iconWindowsLogo from './svg/iconWindowsLogo.svg';
import iconYoutubeLogo from './svg/iconYoutubeLogo.svg';
import iconCalendar from './svg/iconCalendar.svg';
import iconCalendarBlank from './svg/iconCalendarBlank.svg';
import iconCalendarCheck from './svg/iconCalendarCheck.svg';
import iconCalendarPlus from './svg/iconCalendarPlus.svg';
import iconCalendarX from './svg/iconCalendarX.svg';
import iconClock from './svg/iconClock.svg';
import iconClockAfternoon from './svg/iconClockAfternoon.svg';
import iconClockClockwise from './svg/iconClockClockwise.svg';
import iconClockCounterClockwise from './svg/iconClockCounterClockwise.svg';
import iconAlarm from './svg/iconAlarm.svg';
import iconTimer from './svg/iconTimer.svg';
import iconWatch from './svg/iconWatch.svg';
import iconHourglass from './svg/iconHourglass.svg';
import iconHourglassHigh from './svg/iconHourglassHigh.svg';
import iconHourglassLow from './svg/iconHourglassLow.svg';
import iconHourglassMedium from './svg/iconHourglassMedium.svg';
import iconHourglassSimple from './svg/iconHourglassSimple.svg';
import iconHourglassSimpleHigh from './svg/iconHourglassSimpleHigh.svg';
import iconHourglassSimpleLow from './svg/iconHourglassSimpleLow.svg';
import iconHourglassSimpleMedium from './svg/iconHourglassSimpleMedium.svg';
import iconBracketsAngle from './svg/iconBracketsAngle.svg';
import iconBracketsCurly from './svg/iconBracketsCurly.svg';
import iconBracketsRound from './svg/iconBracketsRound.svg';
import iconBracketsSquare from './svg/iconBracketsSquare.svg';
import iconBug from './svg/iconBug.svg';
import iconBugBeetle from './svg/iconBugBeetle.svg';
import iconBugDroid from './svg/iconBugDroid.svg';
import iconCodeSimple from './svg/iconCodeSimple.svg';
import iconCode from './svg/iconCode.svg';
import iconMagnet from './svg/iconMagnet.svg';
import iconMagnetStraight from './svg/iconMagnetStraight.svg';
import iconGitCommit from './svg/iconGitCommit.svg';
import iconGitDiff from './svg/iconGitDiff.svg';
import iconGitPullRequest from './svg/iconGitPullRequest.svg';
import iconTerminal from './svg/iconTerminal.svg';
import iconTerminalWindow from './svg/iconTerminalWindow.svg';
import iconCpu from './svg/iconCpu.svg';
import iconDatabase from './svg/iconDatabase.svg';
import iconRobot from './svg/iconRobot.svg';
import iconBookOpen from './svg/iconBookOpen.svg';
import iconBooks from './svg/iconBooks.svg';
import iconBookmark from './svg/iconBookmark.svg';
import iconBookmarkSimple from './svg/iconBookmarkSimple.svg';
import iconBookmarks from './svg/iconBookmarks.svg';
import iconBookmarksSimple from './svg/iconBookmarksSimple.svg';
import iconChalkboard from './svg/iconChalkboard.svg';
import iconChalkboardSimple from './svg/iconChalkboardSimple.svg';
import iconChalkboardTeacher from './svg/iconChalkboardTeacher.svg';
import iconExam from './svg/iconExam.svg';
import iconGraduationCap from './svg/iconGraduationCap.svg';
import iconStudent from './svg/iconStudent.svg';
import iconActivity from './svg/iconActivity.svg';
import iconBandaids from './svg/iconBandaids.svg';
import iconBarbell from './svg/iconBarbell.svg';
import iconBed from './svg/iconBed.svg';
import iconFirstAid from './svg/iconFirstAid.svg';
import iconFirstAidKit from './svg/iconFirstAidKit.svg';
import iconToilet from './svg/iconToilet.svg';
import iconToiletPaper from './svg/iconToiletPaper.svg';
import iconFlask from './svg/iconFlask.svg';
import iconHeartbeat from './svg/iconHeartbeat.svg';
import iconLifebuoy from './svg/iconLifebuoy.svg';
import iconPill from './svg/iconPill.svg';
import iconPrescription from './svg/iconPrescription.svg';
import iconTestTube from './svg/iconTestTube.svg';
import iconCountry from './svg/iconCountry.svg';
import iconAF from './svg/iconAF.svg';
import iconBO from './svg/iconBO.svg';
import iconHR from './svg/iconHR.svg';
import iconGM from './svg/iconGM.svg';
import iconIL from './svg/iconIL.svg';
import iconML from './svg/iconML.svg';
import iconNF from './svg/iconNF.svg';
import iconSV from './svg/iconSV.svg';
import iconSR from './svg/iconSR.svg';
import iconAX from './svg/iconAX.svg';
import iconBQ from './svg/iconBQ.svg';
import iconCU from './svg/iconCU.svg';
import iconGE from './svg/iconGE.svg';
import iconIT from './svg/iconIT.svg';
import iconMT from './svg/iconMT.svg';
import iconKP from './svg/iconKP.svg';
import iconWS from './svg/iconWS.svg';
import iconSZ from './svg/iconSZ.svg';
import iconAL from './svg/iconAL.svg';
import iconBA from './svg/iconBA.svg';
import iconCW from './svg/iconCW.svg';
import iconDE from './svg/iconDE.svg';
import iconJM from './svg/iconJM.svg';
import iconMH from './svg/iconMH.svg';
import iconMP from './svg/iconMP.svg';
import iconSM from './svg/iconSM.svg';
import iconSE from './svg/iconSE.svg';
import iconDZ from './svg/iconDZ.svg';
import iconBW from './svg/iconBW.svg';
import iconCY from './svg/iconCY.svg';
import iconGH from './svg/iconGH.svg';
import iconJP from './svg/iconJP.svg';
import iconMQ from './svg/iconMQ.svg';
import iconNO from './svg/iconNO.svg';
import iconST from './svg/iconST.svg';
import iconCH from './svg/iconCH.svg';
import iconAS from './svg/iconAS.svg';
import iconBR from './svg/iconBR.svg';
import iconCZ from './svg/iconCZ.svg';
import iconGI from './svg/iconGI.svg';
import iconJE from './svg/iconJE.svg';
import iconMR from './svg/iconMR.svg';
import iconOM from './svg/iconOM.svg';
import iconSA from './svg/iconSA.svg';
import iconSY from './svg/iconSY.svg';
import iconAD from './svg/iconAD.svg';
import iconIO from './svg/iconIO.svg';
import iconCD from './svg/iconCD.svg';
import iconGR from './svg/iconGR.svg';
import iconJO from './svg/iconJO.svg';
import iconMU from './svg/iconMU.svg';
import iconPK from './svg/iconPK.svg';
import iconSN from './svg/iconSN.svg';
import iconTW from './svg/iconTW.svg';
import iconAO from './svg/iconAO.svg';
import iconVG from './svg/iconVG.svg';
import iconDK from './svg/iconDK.svg';
import iconGL from './svg/iconGL.svg';
import iconKZ from './svg/iconKZ.svg';
import iconMX from './svg/iconMX.svg';
import iconPW from './svg/iconPW.svg';
import iconRS from './svg/iconRS.svg';
import iconTJ from './svg/iconTJ.svg';
import iconAI from './svg/iconAI.svg';
import iconBN from './svg/iconBN.svg';
import iconDJ from './svg/iconDJ.svg';
import iconGD from './svg/iconGD.svg';
import iconKE from './svg/iconKE.svg';
import iconFM from './svg/iconFM.svg';
import iconPS from './svg/iconPS.svg';
import iconSC from './svg/iconSC.svg';
import iconTZ from './svg/iconTZ.svg';
import iconAG from './svg/iconAG.svg';
import iconBG from './svg/iconBG.svg';
import iconDM from './svg/iconDM.svg';
import iconGU from './svg/iconGU.svg';
import iconKI from './svg/iconKI.svg';
import iconMD from './svg/iconMD.svg';
import iconPA from './svg/iconPA.svg';
import iconSL from './svg/iconSL.svg';
import iconTH from './svg/iconTH.svg';
import iconAR from './svg/iconAR.svg';
import iconBF from './svg/iconBF.svg';
import iconDO from './svg/iconDO.svg';
import iconGT from './svg/iconGT.svg';
import iconKW from './svg/iconKW.svg';
import iconMC from './svg/iconMC.svg';
import iconPG from './svg/iconPG.svg';
import iconSG from './svg/iconSG.svg';
import iconTG from './svg/iconTG.svg';
import iconAM from './svg/iconAM.svg';
import iconBI from './svg/iconBI.svg';
import iconTL from './svg/iconTL.svg';
import iconGG from './svg/iconGG.svg';
import iconKG from './svg/iconKG.svg';
import iconMN from './svg/iconMN.svg';
import iconPY from './svg/iconPY.svg';
import iconTK from './svg/iconTK.svg';
import iconAW from './svg/iconAW.svg';
import iconKH from './svg/iconKH.svg';
import iconEC from './svg/iconEC.svg';
import iconGW from './svg/iconGW.svg';
import iconLA from './svg/iconLA.svg';
import iconME from './svg/iconME.svg';
import iconPE from './svg/iconPE.svg';
import iconSX from './svg/iconSX.svg';
import iconTO from './svg/iconTO.svg';
import iconAU from './svg/iconAU.svg';
import iconCM from './svg/iconCM.svg';
import iconEG from './svg/iconEG.svg';
import iconGN from './svg/iconGN.svg';
import iconLV from './svg/iconLV.svg';
import iconMS from './svg/iconMS.svg';
import iconPH from './svg/iconPH.svg';
import iconSK from './svg/iconSK.svg';
import iconTT from './svg/iconTT.svg';
import iconAT from './svg/iconAT.svg';
import iconCA from './svg/iconCA.svg';
import iconGB2 from './svg/iconGB2.svg';
import iconGY from './svg/iconGY.svg';
import iconLB from './svg/iconLB.svg';
import iconMA from './svg/iconMA.svg';
import iconPN from './svg/iconPN.svg';
import iconSI from './svg/iconSI.svg';
import iconTN from './svg/iconTN.svg';
import iconAZ from './svg/iconAZ.svg';
import iconKY from './svg/iconKY.svg';
import iconGQ from './svg/iconGQ.svg';
import iconHT from './svg/iconHT.svg';
import iconLS from './svg/iconLS.svg';
import iconMZ from './svg/iconMZ.svg';
import iconPT from './svg/iconPT.svg';
import iconSB from './svg/iconSB.svg';
import iconTR from './svg/iconTR.svg';
import iconBS from './svg/iconBS.svg';
import iconCF from './svg/iconCF.svg';
import iconER from './svg/iconER.svg';
import iconHN from './svg/iconHN.svg';
import iconLR from './svg/iconLR.svg';
import iconMM from './svg/iconMM.svg';
import iconPR from './svg/iconPR.svg';
import iconSO from './svg/iconSO.svg';
import iconTM from './svg/iconTM.svg';
import iconBH from './svg/iconBH.svg';
import iconTD from './svg/iconTD.svg';
import iconEE from './svg/iconEE.svg';
import iconHK from './svg/iconHK.svg';
import iconLY from './svg/iconLY.svg';
import iconNA from './svg/iconNA.svg';
import iconQA from './svg/iconQA.svg';
import iconZA from './svg/iconZA.svg';
import iconTC from './svg/iconTC.svg';
import iconBD from './svg/iconBD.svg';
import iconCL from './svg/iconCL.svg';
import iconET from './svg/iconET.svg';
import iconHU from './svg/iconHU.svg';
import iconLI from './svg/iconLI.svg';
import iconNR from './svg/iconNR.svg';
import iconMK from './svg/iconMK.svg';
import iconKR from './svg/iconKR.svg';
import iconTV from './svg/iconTV.svg';
import iconBB from './svg/iconBB.svg';
import iconCN from './svg/iconCN.svg';
import iconFK from './svg/iconFK.svg';
import iconIS from './svg/iconIS.svg';
import iconLT from './svg/iconLT.svg';
import iconNP from './svg/iconNP.svg';
import iconPL from './svg/iconPL.svg';
import iconSS from './svg/iconSS.svg';
import iconUG from './svg/iconUG.svg';
import iconBY from './svg/iconBY.svg';
import iconCX from './svg/iconCX.svg';
import iconFO from './svg/iconFO.svg';
import iconIN from './svg/iconIN.svg';
import iconLU from './svg/iconLU.svg';
import iconNL from './svg/iconNL.svg';
import iconES from './svg/iconES.svg';
import iconUA from './svg/iconUA.svg';
import iconBE from './svg/iconBE.svg';
import iconCC from './svg/iconCC.svg';
import iconFJ from './svg/iconFJ.svg';
import iconID from './svg/iconID.svg';
import iconMO from './svg/iconMO.svg';
import iconNZ from './svg/iconNZ.svg';
import iconRO from './svg/iconRO.svg';
import iconLK from './svg/iconLK.svg';
import iconAE from './svg/iconAE.svg';
import iconBZ from './svg/iconBZ.svg';
import iconCO from './svg/iconCO.svg';
import iconFI from './svg/iconFI.svg';
import iconIR from './svg/iconIR.svg';
import iconMG from './svg/iconMG.svg';
import iconNI from './svg/iconNI.svg';
import iconRU from './svg/iconRU.svg';
import iconBL from './svg/iconBL.svg';
import iconGB from './svg/iconGB.svg';
import iconBJ from './svg/iconBJ.svg';
import iconKM from './svg/iconKM.svg';
import iconFR from './svg/iconFR.svg';
import iconIQ from './svg/iconIQ.svg';
import iconMW from './svg/iconMW.svg';
import iconNE from './svg/iconNE.svg';
import iconRW from './svg/iconRW.svg';
import iconLC from './svg/iconLC.svg';
import iconUS from './svg/iconUS.svg';
import iconBM from './svg/iconBM.svg';
import iconCK from './svg/iconCK.svg';
import iconPF from './svg/iconPF.svg';
import iconIE from './svg/iconIE.svg';
import iconMY from './svg/iconMY.svg';
import iconNG from './svg/iconNG.svg';
import iconVC from './svg/iconVC.svg';
import iconUY from './svg/iconUY.svg';
import iconBT from './svg/iconBT.svg';
import iconCR from './svg/iconCR.svg';
import iconGA from './svg/iconGA.svg';
import iconIM from './svg/iconIM.svg';
import iconMV from './svg/iconMV.svg';
import iconNU from './svg/iconNU.svg';
import iconKN from './svg/iconKN.svg';
import iconDS from './svg/iconDS.svg';
import iconUZ from './svg/iconUZ.svg';
import iconVU from './svg/iconVU.svg';
import iconVE from './svg/iconVE.svg';
import iconVN from './svg/iconVN.svg';
import iconVI from './svg/iconVI.svg';
import iconEH from './svg/iconEH.svg';
import iconYE from './svg/iconYE.svg';
import iconZM from './svg/iconZM.svg';
import iconZW from './svg/iconZW.svg';
import iconWide from './svg/iconWide.svg';
import iconStacked from './svg/iconStacked.svg';
import iconSmall from './svg/iconSmall.svg';
import iconMedium from './svg/iconMedium.svg';
import iconLarge from './svg/iconLarge.svg';
import iconExtraLarge from './svg/iconExtraLarge.svg';
import iconLetterHalfPortrait from './svg/iconLetterHalfPortrait.svg';
import iconLetterPortrait from './svg/iconLetterPortrait.svg';
import iconLetterHalfLandscape from './svg/iconLetterHalfLandscape.svg';
import iconLetterLandscape from './svg/iconLetterLandscape.svg';
import iconA4HalfPortrait from './svg/iconA4HalfPortrait.svg';
import iconA4Portrait from './svg/iconA4Portrait.svg';
import iconA4HalfLandscape from './svg/iconA4HalfLandscape.svg';
import iconA4Landscape from './svg/iconA4Landscape.svg';
import icon67 from './svg/icon67.svg';
import icon921 from './svg/icon921.svg';
import icon143 from './svg/icon143.svg';
import icon219 from './svg/icon219.svg';
import icon12 from './svg/icon12.svg';
import icon41 from './svg/icon41.svg';
import icon21 from './svg/icon21.svg';
import icon98 from './svg/icon98.svg';
import icon916 from './svg/icon916.svg';
import icon329 from './svg/icon329.svg';
import icon169 from './svg/icon169.svg';
import iconGoldenRatioHalfPortrait from './svg/iconGoldenRatioHalfPortrait.svg';
import iconGoldenRatioPortrait from './svg/iconGoldenRatioPortrait.svg';
import iconGoldenRatioHalfLandscape from './svg/iconGoldenRatioHalfLandscape.svg';
import iconGoldenRatioLandscape from './svg/iconGoldenRatioLandscape.svg';
import icon1016 from './svg/icon1016.svg';
import icon165 from './svg/icon165.svg';
import icon1610 from './svg/icon1610.svg';
import icon23 from './svg/icon23.svg';
import icon31 from './svg/icon31.svg';
import icon32 from './svg/icon32.svg';
import icon34 from './svg/icon34.svg';
import icon83 from './svg/icon83.svg';
import icon43 from './svg/icon43.svg';
import icon85 from './svg/icon85.svg';
import icon45 from './svg/icon45.svg';
import icon52 from './svg/icon52.svg';
import icon54 from './svg/icon54.svg';
import icon11 from './svg/icon11.svg';
import iconFilled from './svg/iconFilled.svg';
import iconEmpty from './svg/iconEmpty.svg';
import iconActive from './svg/iconActive.svg';
import iconDefault from './svg/iconDefault.svg';
import iconPhone from './svg/iconPhone.svg';
import iconHome from './svg/iconHome.svg';
import iconVariant3 from './svg/iconVariant3.svg';
import iconVariant4 from './svg/iconVariant4.svg';
import iconTexas from './svg/iconTexas.svg';
import iconCalifornia from './svg/iconCalifornia.svg';
import iconFlorida from './svg/iconFlorida.svg';

const svgImports = {
  iconArrowLineLeft,
  iconArrowLineRight,
  iconBuildings,
  iconCaretDown,
  iconCaretRight,
  iconCheck,
  iconDiamond,
  iconDotsThreeVertical,
  iconFunnelSimple,
  iconHandWaving,
  iconHouse,
  iconMagnifyingGlass,
  iconNewspaper,
  iconNewspaperClipping,
  iconTrash,
  iconUser,
  iconWarningCircle,
  iconX,
  icon24,
  iconArrowUDownLeft,
  iconArrowUDownRight,
  iconArrowULeftDown,
  iconArrowULeftUp,
  iconArrowURightDown,
  iconArrowURightUp,
  iconArrowUUpLeft,
  iconArrowUUpRight,
  iconArrowsDownUp,
  iconArrowsHorizontal,
  iconArrowsIn,
  iconArrowsInCardinal,
  iconArrowsInLineHorizontal,
  iconArrowsInLineVertical,
  iconArrowsInSimple,
  iconArrowsLeftRight,
  iconArrowsOut,
  iconArrowsOutCardinal,
  iconArrowsOutLineHorizontal,
  iconArrowsOutLineVertical,
  iconArrowsOutSimple,
  iconArrowsVertical,
  iconArrowsCounterClockwise,
  iconArrowsClockwise,
  iconArrowBendLeftDown,
  iconArrowBendLeftUp,
  iconArrowBendDoubleUpLeft,
  iconArrowBendDoubleUpRight,
  iconArrowArcLeft,
  iconArrowArcRight,
  iconArrowBendDownLeft,
  iconArrowBendDownRight,
  iconArrowBendRightDown,
  iconArrowBendRightUp,
  iconArrowBendUpLeft,
  iconArrowBendUpRight,
  iconArrowFatDown,
  iconArrowFatLeft,
  iconArrowFatLineDown,
  iconArrowFatLineLeft,
  iconArrowFatLineRight,
  iconArrowFatLineUp,
  iconArrowFatLinesDown,
  iconArrowFatLinesLeft,
  iconArrowFatLinesRight,
  iconArrowFatLinesUp,
  iconArrowFatRight,
  iconArrowFatUp,
  iconCaretCircleDoubleDown,
  iconCaretCircleDoubleLeft,
  iconCaretCircleDoubleRight,
  iconCaretCircleDoubleUp,
  iconCaretCircleDown,
  iconCaretCircleLeft,
  iconCaretCircleRight,
  iconCaretCircleUp,
  iconVariant10,
  iconVariant9,
  iconCaretUp,
  iconCaretLeft,
  iconArrowSquareDown,
  iconArrowSquareDownLeft,
  iconArrowSquareDownRight,
  iconArrowSquareIn,
  iconArrowSquareLeft,
  iconArrowSquareOut,
  iconArrowSquareRight,
  iconArrowSquareUp,
  iconArrowSquareUpLeft,
  iconArrowSquareUpRight,
  iconDown,
  iconDownLeft,
  iconDownRight,
  iconLeft,
  iconRight,
  iconUp,
  iconUpLeft,
  iconUpRight,
  iconDirections10,
  iconDirections9,
  iconLeftDown,
  iconLeftUp,
  iconRightDown,
  iconRightUp,
  iconArrowLineDown,
  iconArrowLineDownLeft,
  iconArrowLineDownRight,
  iconArrowLineUp,
  iconArrowLineUpLeft,
  iconArrowLineUpRight,
  iconFile,
  iconFileArrowDown,
  iconFileArrowUp,
  iconFileAudio,
  iconFileCloud,
  iconFileCode,
  iconFileCss,
  iconFileCsv,
  iconFileDoc,
  iconFileDotted,
  iconFileHtml,
  iconFileImage,
  iconFileJpg,
  iconFileJs,
  iconFileJsx,
  iconFileLock,
  iconFileMinus,
  iconFilePdf,
  iconFilePlus,
  iconFilePng,
  iconFilePpt,
  iconFileRs,
  iconFileSearch,
  iconFileText,
  iconFileTs,
  iconFileTsx,
  iconFileVideo,
  iconFileVue,
  iconFileX,
  iconFileXls,
  iconFileZip,
  iconFiles,
  iconTextAa,
  iconTextBolder,
  iconTextH,
  iconTextHFive,
  iconTextHFour,
  iconTextHOne,
  iconTextHSix,
  iconTextHThree,
  iconTextIndent,
  iconTextItalic,
  iconTextOutdent,
  iconTextStrikethrough,
  iconTextT,
  iconTextUnderline,
  iconTextbox,
  iconCursorText,
  iconFolder,
  iconFolderDotted,
  iconFolderLock,
  iconFolderMinus,
  iconFolderNotch,
  iconFolderNotchMinus,
  iconFolderNotchPlus,
  iconFolderPlus,
  iconFolderSimple,
  iconFolderSimpleDotted,
  iconFolderSimpleLock,
  iconFolderSimpleMinus,
  iconFolderSimplePlus,
  iconFolderSimpleStar,
  iconFolderSimpleUser,
  iconFolderStar,
  iconFolderUser,
  iconFolders,
  iconListChecks,
  iconListDashes,
  iconListNumbers,
  iconListPlus,
  iconList,
  iconListBullets,
  iconTextAlignCenter,
  iconTextAlignJustify,
  iconTextAlignLeft,
  iconTextAlignRight,
  iconNote,
  iconNoteBlank,
  iconNotePencil,
  iconNotebook,
  iconNotepad,
  iconKanban,
  iconPresentation,
  iconPresentationChart,
  iconPrinter,
  iconProjectorScreen,
  iconFloppyDisk,
  iconProjectorScreenChart,
  iconFloppyDiskBack,
  iconArchive,
  iconArchiveBox,
  iconCards,
  iconClipboard,
  iconClipboardText,
  iconPushPin,
  iconPushPinSimple,
  iconPushPinSimpleSlash,
  iconSortAscending,
  iconSortDescending,
  iconCopy,
  iconCopySimple,
  iconBriefcase,
  iconBriefcaseMetal,
  iconTrashSimple,
  iconPaperclip,
  iconPaperclipHorizontal,
  iconBellRinging,
  iconBellSlash,
  iconBellSimpleRinging,
  iconBluetooth,
  iconBluetoothConnected,
  iconBluetoothSlash,
  iconBluetoothX,
  iconCellSignalFull,
  iconCellSignalHigh,
  iconCellSignalLow,
  iconCellSignalMedium,
  iconCellSignalNone,
  iconCellSignalSlash,
  iconCellSignalX,
  iconFalse,
  iconTrue,
  iconMagnifyingGlassMinus,
  iconMagnifyingGlassPlus,
  iconBatteryCharging,
  iconBatteryChargingVertical,
  iconBatteryEmpty,
  iconBatteryFull,
  iconBatteryHigh,
  iconBatteryLow,
  iconBatteryMedium,
  iconBatteryPlus,
  iconBatteryWarning,
  iconBatteryWarningVertical,
  iconPlug,
  iconPlugs,
  iconPlugsConnected,
  iconHardDrive,
  iconHardDrives,
  iconLink,
  iconLinkBreak,
  iconLinkSimple,
  iconLinkSimpleBreak,
  iconLinkSimpleHorizontal,
  iconLinkSimpleHorizontalBreak,
  iconMonitor,
  iconMonitorPlay,
  iconMouse,
  iconMouseSimple,
  iconSignIn,
  iconSignOut,
  iconSpinner,
  iconSpinnerGap,
  iconBrowser,
  iconBrowsers,
  iconAppWindow,
  iconBackspace,
  iconCommand,
  iconComputerTower,
  iconCursor,
  iconLaptop,
  iconFlashlight,
  iconGauge,
  iconPower,
  iconScan,
  iconQrCode,
  iconSwap,
  iconNotification,
  iconRadioButton,
  iconNut,
  iconGearSix,
  iconSimCard,
  iconVibrate,
  iconWrench,
  iconWifiHigh,
  iconWifiLow,
  iconWifiMedium,
  iconWifiNone,
  iconWifiSlash,
  iconWifiX,
  iconLightning,
  iconLightningSlash,
  iconKeyReturn,
  iconKeyboard,
  iconCheckCircle,
  iconCheckSquareFilled,
  iconCheckSquareEmpty,
  iconCheckSquareOffset,
  iconChecks,
  iconCloudCheck,
  iconCloudSlash,
  iconCloudArrowDown,
  iconCloudArrowUp,
  iconDesktop,
  iconDesktopTower,
  iconDownload,
  iconDownloadSimple,
  iconUpload,
  iconUploadSimple,
  iconDeviceMobile,
  iconDeviceMobileCamera,
  iconDeviceMobileSpeaker,
  iconDeviceTablet,
  iconDeviceTabletCamera,
  iconDeviceTabletSpeaker,
  iconDotsNine,
  iconDotsSix,
  iconDotsSixVertical,
  iconDotsThree,
  iconDotsThreeCircle,
  iconDotsThreeCircleVertical,
  iconDotsThreeOutline,
  iconDotsThreeOutlineVertical,
  iconWarning,
  iconMagicWand,
  iconMarkerCircle,
  iconEyedropper,
  iconIntersect,
  iconFlowArrow,
  iconGradient,
  iconDiamondsFour,
  iconDropHalf,
  iconDropHalfBottom,
  iconEraser,
  iconRuler,
  iconScissors,
  iconBezierCurve,
  iconBoundingBox,
  iconSwatches,
  iconVignette,
  iconAlignBottom,
  iconAlignBottomSimple,
  iconAlignCenterHorizontal,
  iconAlignCenterHorizontalSimple,
  iconAlignCenterVertical,
  iconAlignCenterVerticalSimple,
  iconAlignLeft,
  iconAlignLeftSimple,
  iconAlignRight,
  iconAlignRightSimple,
  iconAlignTop,
  iconAlignTopSimple,
  iconEyeSlash,
  iconEye,
  iconEyeClosed,
  iconSelection,
  iconSelectionAll,
  iconSelectionBackground,
  iconSelectionForeground,
  iconSelectionInverse,
  iconSelectionPlus,
  iconSelectionSlash,
  iconCrop,
  iconRectangle,
  iconSquare,
  iconTriangle,
  iconHexagon,
  iconCylinder,
  iconCube,
  iconCircle,
  iconCircleDashed,
  iconCircleHalf,
  iconCircleHalfTilt,
  iconCircleNotch,
  iconCirclesFour,
  iconCirclesThree,
  iconCirclesThreePlus,
  iconLineSegment,
  iconLineSegments,
  iconLayout,
  iconGridFour,
  iconRows,
  iconSidebar,
  iconSidebarSimple,
  iconSquareHalf,
  iconColumns,
  iconPlaceholder,
  iconPolygon,
  iconSquareHalfBottom,
  iconSquaresFour,
  iconStack,
  iconStackSimple,
  iconHighlighterCircle,
  iconPaintBrushHousehold,
  iconPaintBucket,
  iconPaintRoller,
  iconPaintBrush,
  iconPencilCircle,
  iconPenNib,
  iconPenNibStraight,
  iconVideoCamera,
  iconVideoCameraSlash,
  iconArticle,
  iconArticleMedium,
  iconArticleNyTimes,
  iconCamera,
  iconCameraRotate,
  iconCameraSlash,
  iconEject,
  iconEjectSimple,
  iconFilmSlate,
  iconFilmStrip,
  iconFilmScript,
  iconMediaMiscClosedCaptioning,
  iconCopyleft,
  iconCopyright,
  iconCornersIn,
  iconFrameCorners,
  iconCornersOut,
  iconMediaMiscDisc,
  iconEar,
  iconEarSlash,
  iconFaders,
  iconFadersHorizontal,
  iconImage,
  iconImageSquare,
  iconCastAirplay,
  iconScreencast,
  iconTelevision,
  iconTelevisionSimple,
  iconHeadphones,
  iconHeadset,
  iconMicrophone,
  iconMicrophoneSlash,
  iconMicrophoneStage,
  iconMusicNote,
  iconMusicNoteSimple,
  iconMusicNotes,
  iconMusicNotesPlus,
  iconMusicNotesSimple,
  iconWaveSawtooth,
  iconWaveSine,
  iconWaveSquare,
  iconWaveTriangle,
  iconSliders,
  iconSlidersHorizontal,
  iconPlay,
  iconPause,
  iconRecord,
  iconRepeat,
  iconRepeatOnce,
  iconShuffle,
  iconShuffleAngular,
  iconShuffleSimple,
  iconSkipBack,
  iconSkipForward,
  iconStop,
  iconStopCircle,
  iconPauseCircle,
  iconPlaylist,
  iconQueue,
  iconSpeakerHigh,
  iconSpeakerLow,
  iconSpeakerNone,
  iconSpeakerSimpleHigh,
  iconSpeakerSimpleLow,
  iconSpeakerSimpleNone,
  iconSpeakerSimpleSlash,
  iconSpeakerSimpleX,
  iconSpeakerSlash,
  iconSpeakerX,
  iconEqualizer,
  iconPianoKeys,
  iconPictureInPicture,
  iconWebcam,
  iconAperture,
  iconChat,
  iconChatCentered,
  iconChatCenteredDots,
  iconChatCenteredText,
  iconChatCircle,
  iconChatCircleDots,
  iconChatCircleText,
  iconChatDots,
  iconChatTeardrop,
  iconChatTeardropDots,
  iconChatTeardropText,
  iconChatText,
  iconChats,
  iconChatsTeardrop,
  iconChatsCircle,
  iconShare,
  iconShareNetwork,
  iconEnvelope,
  iconEnvelopeOpen,
  iconEnvelopeSimple,
  iconEnvelopeSimpleOpen,
  iconPaperPlane,
  iconPaperPlaneRight,
  iconPaperPlaneTilt,
  iconAsterisk,
  iconAsteriskSimple,
  iconHash,
  iconHashStraight,
  iconPhoneDisconnect,
  iconPhoneSlash,
  iconMegaphoneSimple,
  iconMegaphone,
  iconRss,
  iconRssSimple,
  iconBroadcast,
  iconAddressBook,
  iconPeace,
  iconQuotes,
  iconSticker,
  iconRadio,
  iconTranslate,
  iconVoicemail,
  iconYinYang,
  iconExport,
  iconStarHalf,
  iconStar,
  iconHeart,
  iconScales,
  iconStorefront,
  iconTShirt,
  iconTag,
  iconTagChevron,
  iconTagSimple,
  iconReceipt,
  iconRug,
  iconPackage,
  iconTrademarkRegistered,
  iconWallet,
  iconGift,
  iconBinoculars,
  iconArmchair,
  iconBalloon,
  iconBarcode,
  iconBathtub,
  iconCoatHanger,
  iconFactory,
  iconLadder,
  iconLadderSimple,
  iconLamp,
  iconBag,
  iconBagSimple,
  iconShoppingBag,
  iconShoppingBagOpen,
  iconHandbag,
  iconHandbagSimple,
  iconTote,
  iconToteSimple,
  iconBackpack,
  iconCoin,
  iconCoinVertical,
  iconCoins,
  iconCreditCard,
  iconMoney,
  iconMartini,
  iconHamburger,
  iconWine,
  iconCookie,
  iconEgg,
  iconEggCrack,
  iconPizza,
  iconPopcorn,
  iconCoffee,
  iconBrandy,
  iconBeerBottle,
  iconKnife,
  iconForkKnife,
  iconCurrencyBtc,
  iconCurrencyCircleDollar,
  iconCurrencyDollar,
  iconCurrencyDollarSimple,
  iconCurrencyEth,
  iconCurrencyEur,
  iconCurrencyGbp,
  iconCurrencyInr,
  iconCurrencyJpy,
  iconCurrencyKrw,
  iconCurrencyKzt,
  iconCurrencyNgn,
  iconCurrencyRub,
  iconPercent,
  iconPlus,
  iconPlusCircle,
  iconPlusMinus,
  iconRadical,
  iconDivide,
  iconEquals,
  iconFunction,
  iconMathOperations,
  iconMinus,
  iconMinusCircle,
  iconXCircle,
  iconXSquare,
  iconTable,
  iconGraph,
  iconInfinity,
  iconBank,
  iconCalculator,
  iconChartBar,
  iconChartBarHorizontal,
  iconChartLine,
  iconChartLineUp,
  iconChartPie,
  iconTrendDown,
  iconTrendUp,
  iconNumberCircleZero,
  iconNumberCircleOne,
  iconNumberCircleThree,
  iconNumberCircleFour,
  iconNumberCircleFive,
  iconNumberCircleSix,
  iconNumberCircleSeven,
  iconNumberCircleEight,
  iconNumberCircleNine,
  iconNumberZero,
  iconNumberOne,
  iconNumberTwo,
  iconNumberThree,
  iconNumberFour,
  iconNumberFive,
  iconNumberSix,
  iconNumberSeven,
  iconNumberNine,
  iconNumberSquareZero,
  iconNumberSquareOne,
  iconNumberSquareThree,
  iconNumberSquareFour,
  iconNumberSquareFive,
  iconNumberSquareSix,
  iconNumberSquareSeven,
  iconNumberSquareEight,
  iconNumberSquareNine,
  iconAirplane,
  iconAirplaneLanding,
  iconAirplaneTakeoff,
  iconAirplaneTilt,
  iconGlobe,
  iconGlobeHemisphereEast,
  iconGlobeHemisphereWest,
  iconGlobeSimple,
  iconGlobeStand,
  iconTrafficCone,
  iconBarricade,
  iconTrafficSignal,
  iconSignpost,
  iconHouseLine,
  iconHouseSimple,
  iconMapPin,
  iconMapPinLine,
  iconMapTrifold,
  iconNavigationArrow,
  iconPath,
  iconCompass,
  iconCrosshair,
  iconCrosshairSimple,
  iconAnchor,
  iconAnchorSimple,
  iconFlag,
  iconFlagBanner,
  iconFlagCheckered,
  iconRocket,
  iconRocketLaunch,
  iconTruck,
  iconJeep,
  iconPoliceCar,
  iconCar,
  iconCarSimple,
  iconBicycle,
  iconTrainSimple,
  iconTrain,
  iconBoat,
  iconSuitcase,
  iconSuitcaseSimple,
  iconDoor,
  iconGasPump,
  iconThermometer,
  iconThermometerCold,
  iconThermometerHot,
  iconThermometerSimple,
  iconMoonStars,
  iconMountains,
  iconPlanet,
  iconRainbow,
  iconSnowflake,
  iconSparkle,
  iconStarFour,
  iconSun,
  iconSunDim,
  iconSunHorizon,
  iconWind,
  iconBird,
  iconButterfly,
  iconDog,
  iconFish,
  iconFishSimple,
  iconCat,
  iconPawPrint,
  iconAtom,
  iconTree,
  iconTreeEvergreen,
  iconCactus,
  iconFlower,
  iconFlowerLotus,
  iconLeaf,
  iconCloudLightning,
  iconCloudRain,
  iconCloudSnow,
  iconCloudSun,
  iconCloud,
  iconCloudFog,
  iconFireSimple,
  iconDrop,
  iconFire,
  iconCampfire,
  iconUserCircleGear,
  iconUserCircle,
  iconUserFocus,
  iconUserGear,
  iconUserList,
  iconUserMinus,
  iconUserPlus,
  iconUserRectangle,
  iconUserSquare,
  iconUserSwitch,
  iconUsersFour,
  iconUsersThree,
  iconIdentificationBadge,
  iconIdentificationCard,
  iconGenderFemale,
  iconGenderIntersex,
  iconGenderMale,
  iconGenderNeuter,
  iconGenderNonbinary,
  iconGenderTransgender,
  iconHandEye,
  iconHand,
  iconHandGrabbing,
  iconHandPalm,
  iconHandPointing,
  iconHandsClapping,
  iconHandshake,
  iconSmiley,
  iconSmileyBlank,
  iconSmileyMeh,
  iconSmileyNervous,
  iconSmileySad,
  iconSmileyWink,
  iconSmileyXEyes,
  iconBaby,
  iconPerson,
  iconWheelchair,
  iconPersonSimpleRun,
  iconPersonSimpleWalk,
  iconShield,
  iconShieldCheck,
  iconShieldCheckered,
  iconShieldChevron,
  iconShieldPlus,
  iconShieldSlash,
  iconShieldStar,
  iconShieldWarning,
  iconLock,
  iconLockKey,
  iconLockKeyOpen,
  iconLockLaminated,
  iconLockLaminatedOpen,
  iconLockOpen,
  iconLockSimple,
  iconLockSimpleOpen,
  iconCircleWavy,
  iconCircleWavyCheck,
  iconCircleWavyQuestion,
  iconCircleWavyWarning,
  iconProhibit,
  iconProhibitInset,
  iconQuestion,
  iconInfo,
  iconDetective,
  iconKey,
  iconVault,
  iconWall,
  iconPassword,
  iconGhost,
  iconAlien,
  iconConfetti,
  iconCrown,
  iconHorse,
  iconCrownSimple,
  iconMaskHappy,
  iconMaskSad,
  iconMedal,
  iconParachute,
  iconPinwheel,
  iconStrategy,
  iconSword,
  iconFinnTheHuman,
  iconPuzzlePiece,
  iconTarget,
  iconDiceFive,
  iconDiceFour,
  iconDiceOne,
  iconDiceSix,
  iconDiceThree,
  iconDiceTwo,
  iconHeartStraight,
  iconHeartStraightBreak,
  iconBasketball,
  iconBaseball,
  iconVolleyball,
  iconSoccerBall,
  iconFootball,
  iconPokerChip,
  iconClub,
  iconSpade,
  iconGamesRewards,
  iconAndroidLogo,
  iconAngularLogo,
  iconAppStoreLogo,
  iconBehanceLogo,
  iconCodepenLogo,
  iconCodesandboxLogo,
  iconDribbbleLogo,
  iconFacebookLogo,
  iconFigmaLogo,
  iconFramerLogo,
  iconGitlabLogo,
  iconGitlabLogoSimple,
  iconGoogleChromeLogo,
  iconGoogleLogo,
  iconGooglePhotosLogo,
  iconGooglePlayLogo,
  iconGooglePodcastsLogo,
  iconInstagramLogo,
  iconLinkedinLogo,
  iconMediumLogo,
  iconMessengerLogo,
  iconMicrosoftExcelLogo,
  iconMicrosoftPowerpointLogo,
  iconMicrosoftWordLogo,
  iconNyTimesLogo,
  iconPinterestLogo,
  iconSketchLogo,
  iconSnapchatLogo,
  iconSquareLogo,
  iconStackOverflowLogo,
  iconStripeLogo,
  iconTelegramLogo,
  iconTiktokLogo,
  iconTwitchLogo,
  iconTwitterLogo,
  iconWindowsLogo,
  iconYoutubeLogo,
  iconCalendar,
  iconCalendarBlank,
  iconCalendarCheck,
  iconCalendarPlus,
  iconCalendarX,
  iconClock,
  iconClockAfternoon,
  iconClockClockwise,
  iconClockCounterClockwise,
  iconAlarm,
  iconTimer,
  iconWatch,
  iconHourglass,
  iconHourglassHigh,
  iconHourglassLow,
  iconHourglassMedium,
  iconHourglassSimple,
  iconHourglassSimpleHigh,
  iconHourglassSimpleLow,
  iconHourglassSimpleMedium,
  iconBracketsAngle,
  iconBracketsCurly,
  iconBracketsRound,
  iconBracketsSquare,
  iconBug,
  iconBugBeetle,
  iconBugDroid,
  iconCodeSimple,
  iconCode,
  iconMagnet,
  iconMagnetStraight,
  iconGitCommit,
  iconGitDiff,
  iconGitPullRequest,
  iconTerminal,
  iconTerminalWindow,
  iconCpu,
  iconDatabase,
  iconRobot,
  iconBookOpen,
  iconBooks,
  iconBookmark,
  iconBookmarkSimple,
  iconBookmarks,
  iconBookmarksSimple,
  iconChalkboard,
  iconChalkboardSimple,
  iconChalkboardTeacher,
  iconExam,
  iconGraduationCap,
  iconStudent,
  iconActivity,
  iconBandaids,
  iconBarbell,
  iconBed,
  iconFirstAid,
  iconFirstAidKit,
  iconToilet,
  iconToiletPaper,
  iconFlask,
  iconHeartbeat,
  iconLifebuoy,
  iconPill,
  iconPrescription,
  iconTestTube,
  iconCountry,
  iconAF,
  iconBO,
  iconHR,
  iconGM,
  iconIL,
  iconML,
  iconNF,
  iconSV,
  iconSR,
  iconAX,
  iconBQ,
  iconCU,
  iconGE,
  iconIT,
  iconMT,
  iconKP,
  iconWS,
  iconSZ,
  iconAL,
  iconBA,
  iconCW,
  iconDE,
  iconJM,
  iconMH,
  iconMP,
  iconSM,
  iconSE,
  iconDZ,
  iconBW,
  iconCY,
  iconGH,
  iconJP,
  iconMQ,
  iconNO,
  iconST,
  iconCH,
  iconAS,
  iconBR,
  iconCZ,
  iconGI,
  iconJE,
  iconMR,
  iconOM,
  iconSA,
  iconSY,
  iconAD,
  iconIO,
  iconCD,
  iconGR,
  iconJO,
  iconMU,
  iconPK,
  iconSN,
  iconTW,
  iconAO,
  iconVG,
  iconDK,
  iconGL,
  iconKZ,
  iconMX,
  iconPW,
  iconRS,
  iconTJ,
  iconAI,
  iconBN,
  iconDJ,
  iconGD,
  iconKE,
  iconFM,
  iconPS,
  iconSC,
  iconTZ,
  iconAG,
  iconBG,
  iconDM,
  iconGU,
  iconKI,
  iconMD,
  iconPA,
  iconSL,
  iconTH,
  iconAR,
  iconBF,
  iconDO,
  iconGT,
  iconKW,
  iconMC,
  iconPG,
  iconSG,
  iconTG,
  iconAM,
  iconBI,
  iconTL,
  iconGG,
  iconKG,
  iconMN,
  iconPY,
  iconTK,
  iconAW,
  iconKH,
  iconEC,
  iconGW,
  iconLA,
  iconME,
  iconPE,
  iconSX,
  iconTO,
  iconAU,
  iconCM,
  iconEG,
  iconGN,
  iconLV,
  iconMS,
  iconPH,
  iconSK,
  iconTT,
  iconAT,
  iconCA,
  iconGB2,
  iconGY,
  iconLB,
  iconMA,
  iconPN,
  iconSI,
  iconTN,
  iconAZ,
  iconKY,
  iconGQ,
  iconHT,
  iconLS,
  iconMZ,
  iconPT,
  iconSB,
  iconTR,
  iconBS,
  iconCF,
  iconER,
  iconHN,
  iconLR,
  iconMM,
  iconPR,
  iconSO,
  iconTM,
  iconBH,
  iconTD,
  iconEE,
  iconHK,
  iconLY,
  iconNA,
  iconQA,
  iconZA,
  iconTC,
  iconBD,
  iconCL,
  iconET,
  iconHU,
  iconLI,
  iconNR,
  iconMK,
  iconKR,
  iconTV,
  iconBB,
  iconCN,
  iconFK,
  iconIS,
  iconLT,
  iconNP,
  iconPL,
  iconSS,
  iconUG,
  iconBY,
  iconCX,
  iconFO,
  iconIN,
  iconLU,
  iconNL,
  iconES,
  iconUA,
  iconBE,
  iconCC,
  iconFJ,
  iconID,
  iconMO,
  iconNZ,
  iconRO,
  iconLK,
  iconAE,
  iconBZ,
  iconCO,
  iconFI,
  iconIR,
  iconMG,
  iconNI,
  iconRU,
  iconBL,
  iconGB,
  iconBJ,
  iconKM,
  iconFR,
  iconIQ,
  iconMW,
  iconNE,
  iconRW,
  iconLC,
  iconUS,
  iconBM,
  iconCK,
  iconPF,
  iconIE,
  iconMY,
  iconNG,
  iconVC,
  iconUY,
  iconBT,
  iconCR,
  iconGA,
  iconIM,
  iconMV,
  iconNU,
  iconKN,
  iconDS,
  iconUZ,
  iconVU,
  iconVE,
  iconVN,
  iconVI,
  iconEH,
  iconYE,
  iconZM,
  iconZW,
  iconWide,
  iconStacked,
  iconSmall,
  iconMedium,
  iconLarge,
  iconExtraLarge,
  iconLetterHalfPortrait,
  iconLetterPortrait,
  iconLetterHalfLandscape,
  iconLetterLandscape,
  iconA4HalfPortrait,
  iconA4Portrait,
  iconA4HalfLandscape,
  iconA4Landscape,
  icon67,
  icon921,
  icon143,
  icon219,
  icon12,
  icon41,
  icon21,
  icon98,
  icon916,
  icon329,
  icon169,
  iconGoldenRatioHalfPortrait,
  iconGoldenRatioPortrait,
  iconGoldenRatioHalfLandscape,
  iconGoldenRatioLandscape,
  icon1016,
  icon165,
  icon1610,
  icon23,
  icon31,
  icon32,
  icon34,
  icon83,
  icon43,
  icon85,
  icon45,
  icon52,
  icon54,
  icon11,
  iconFilled,
  iconEmpty,
  iconActive,
  iconDefault,
  iconPhone,
  iconHome,
  iconVariant3,
  iconVariant4,
  iconTexas,
  iconCalifornia,
  iconFlorida
};

export { svgImports };
